var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 361.77 141.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-101,.cls-120,.cls-128,.cls-134,.cls-135,.cls-136,.cls-183,.cls-184,.cls-185,.cls-186,.cls-187,.cls-188,.cls-189,.cls-190,.cls-191,.cls-192,.cls-193,.cls-194,.cls-2,.cls-221,.cls-222,.cls-225,.cls-227,.cls-26,.cls-27,.cls-3,.cls-4,.cls-47,.cls-48,.cls-5,.cls-53,.cls-54,.cls-55,.cls-56,.cls-6,.cls-71,.cls-74,.cls-75,.cls-76,.cls-78,.cls-79{mix-blend-mode:multiply;}.cls-2{fill:url(#radial-gradient);}.cls-3{fill:url(#radial-gradient-2);}.cls-4{fill:url(#radial-gradient-3);}.cls-5{fill:url(#radial-gradient-4);}.cls-6{fill:url(#radial-gradient-5);}.cls-7{fill:url(#radial-gradient-6);}.cls-8{fill:url(#radial-gradient-7);}.cls-9{fill:url(#radial-gradient-8);}.cls-10{fill:url(#radial-gradient-9);}.cls-11{fill:url(#radial-gradient-10);}.cls-12{fill:url(#radial-gradient-11);}.cls-13{fill:url(#radial-gradient-12);}.cls-14{fill:url(#radial-gradient-13);}.cls-15{fill:url(#radial-gradient-14);}.cls-16{fill:url(#linear-gradient);}.cls-17{fill:url(#linear-gradient-2);}.cls-18{fill:url(#linear-gradient-3);}.cls-19{fill:url(#linear-gradient-4);}.cls-20{fill:url(#linear-gradient-5);}.cls-21{fill:url(#linear-gradient-6);}.cls-22{fill:url(#linear-gradient-7);}.cls-23{fill:url(#linear-gradient-8);}.cls-24{fill:url(#linear-gradient-9);}.cls-25{fill:url(#linear-gradient-10);}.cls-26{fill:url(#radial-gradient-15);}.cls-27{fill:url(#linear-gradient-11);}.cls-28{fill:url(#radial-gradient-16);}.cls-29{fill:url(#radial-gradient-17);}.cls-30{fill:url(#radial-gradient-18);}.cls-31{fill:url(#radial-gradient-19);}.cls-32{fill:url(#radial-gradient-20);}.cls-33{fill:url(#radial-gradient-21);}.cls-34{fill:url(#radial-gradient-22);}.cls-35{fill:url(#radial-gradient-23);}.cls-36{fill:url(#radial-gradient-24);}.cls-37{fill:url(#linear-gradient-12);}.cls-38{fill:url(#linear-gradient-13);}.cls-39{fill:url(#linear-gradient-14);}.cls-40{fill:url(#linear-gradient-15);}.cls-41{fill:url(#linear-gradient-16);}.cls-42{fill:url(#linear-gradient-17);}.cls-43{fill:url(#linear-gradient-18);}.cls-44{fill:url(#linear-gradient-19);}.cls-45{fill:url(#linear-gradient-20);}.cls-46{fill:url(#linear-gradient-21);}.cls-47{fill:url(#radial-gradient-25);}.cls-48{fill:url(#linear-gradient-22);}.cls-49{fill:url(#radial-gradient-26);}.cls-50{fill:url(#linear-gradient-23);}.cls-51{fill:url(#linear-gradient-24);}.cls-52{fill:url(#linear-gradient-25);}.cls-53{fill:url(#linear-gradient-26);}.cls-54{fill:url(#radial-gradient-27);}.cls-100,.cls-55{fill:#b8b8be;}.cls-56{fill:url(#linear-gradient-27);}.cls-57{fill:url(#linear-gradient-28);}.cls-58{fill:url(#linear-gradient-29);}.cls-59{fill:#7f7f83;}.cls-100,.cls-110,.cls-111,.cls-112,.cls-113,.cls-114,.cls-115,.cls-116,.cls-117,.cls-118,.cls-119,.cls-170,.cls-171,.cls-172,.cls-173,.cls-174,.cls-175,.cls-176,.cls-177,.cls-178,.cls-59,.cls-60,.cls-61,.cls-62,.cls-63,.cls-64,.cls-65,.cls-66,.cls-67,.cls-68,.cls-69,.cls-70,.cls-72,.cls-80,.cls-81,.cls-82,.cls-83,.cls-84,.cls-85,.cls-86,.cls-87,.cls-88,.cls-89,.cls-90,.cls-91,.cls-92,.cls-93,.cls-94,.cls-95,.cls-96,.cls-97,.cls-98,.cls-99{mix-blend-mode:overlay;}.cls-60{fill:#868688;}.cls-61{fill:#8c8c8e;}.cls-62{fill:#939393;}.cls-63{fill:#999998;}.cls-64{fill:#a0a09e;}.cls-65{fill:#a6a6a3;}.cls-66{fill:#adada9;}.cls-67{fill:#b3b3ae;}.cls-68{fill:#babab3;}.cls-69{fill:#c0c0b9;}.cls-70{fill:#c7c7be;}.cls-71{fill:url(#linear-gradient-30);}.cls-72{fill:url(#linear-gradient-31);}.cls-105,.cls-106,.cls-107,.cls-108,.cls-109,.cls-122,.cls-124,.cls-125,.cls-126,.cls-153,.cls-154,.cls-155,.cls-156,.cls-157,.cls-158,.cls-159,.cls-160,.cls-161,.cls-162,.cls-163,.cls-164,.cls-165,.cls-166,.cls-167,.cls-168,.cls-169,.cls-73{mix-blend-mode:soft-light;}.cls-74{fill:url(#linear-gradient-32);}.cls-75{fill:url(#linear-gradient-33);}.cls-76{fill:url(#linear-gradient-34);}.cls-77{fill:url(#linear-gradient-35);}.cls-78{fill:url(#linear-gradient-36);}.cls-79{fill:url(#linear-gradient-37);}.cls-80{fill:#848488;}.cls-81{fill:#89898d;}.cls-82{fill:#8e8e93;}.cls-83{fill:#939398;}.cls-84{fill:#98989d;}.cls-85{fill:#9d9da2;}.cls-86{fill:#a2a2a7;}.cls-87{fill:#a7a7ac;}.cls-88{fill:#acacb2;}.cls-89{fill:#b1b1b7;}.cls-90{fill:#b6b6bc;}.cls-91{fill:#89898e;}.cls-92{fill:#8f8f93;}.cls-93{fill:#949498;}.cls-94{fill:#99999e;}.cls-95{fill:#9e9ea3;}.cls-96{fill:#a3a3a9;}.cls-97{fill:#a8a8ae;}.cls-98{fill:#aeaeb3;}.cls-99{fill:#b3b3b9;}.cls-101{fill:url(#linear-gradient-38);}.cls-102{fill:url(#linear-gradient-39);}.cls-103{fill:url(#linear-gradient-41);}.cls-104,.cls-127,.cls-153,.cls-154,.cls-155,.cls-156,.cls-157,.cls-158,.cls-159,.cls-160,.cls-161,.cls-162,.cls-163,.cls-164,.cls-165,.cls-166,.cls-167,.cls-168,.cls-169,.cls-183,.cls-217{fill:#fff;}.cls-104{opacity:0.52;}.cls-105{fill:url(#linear-gradient-42);}.cls-106{fill:url(#linear-gradient-43);}.cls-107{fill:url(#linear-gradient-44);}.cls-108{fill:url(#linear-gradient-45);}.cls-109{fill:url(#linear-gradient-46);}.cls-110{fill:#838387;}.cls-111{fill:#86868b;}.cls-112{fill:#8a8a8f;}.cls-113{fill:#929297;}.cls-114{fill:#95959b;}.cls-115{fill:#99999f;}.cls-116{fill:#9d9da3;}.cls-117{fill:#a1a1a7;}.cls-118{fill:#a4a4ab;}.cls-119{fill:#a8a8af;}.cls-121,.cls-128{fill:#bd0000;}.cls-122{fill:url(#linear-gradient-47);}.cls-123{fill:#e50000;}.cls-124{fill:url(#linear-gradient-48);}.cls-125{fill:url(#linear-gradient-49);}.cls-126{fill:url(#linear-gradient-50);}.cls-127{opacity:0.2;}.cls-129{fill:url(#linear-gradient-51);}.cls-130{fill:url(#linear-gradient-52);}.cls-131{fill:url(#linear-gradient-53);}.cls-132{fill:#232628;}.cls-133{fill:url(#linear-gradient-54);}.cls-134{fill:#a8b3af;}.cls-135{fill:url(#linear-gradient-55);}.cls-136{fill:url(#linear-gradient-56);}.cls-137{fill:#282b2d;}.cls-138{fill:#26292b;}.cls-139{fill:#24282a;}.cls-140{fill:#212426;}.cls-141{fill:#1f2224;}.cls-142{fill:#1d2123;}.cls-143{fill:#1b1f21;}.cls-144{fill:#1a1d1f;}.cls-145{fill:#181b1d;}.cls-146{fill:#161a1c;}.cls-147{fill:#14181a;}.cls-148{fill:#121618;}.cls-149{fill:#101416;}.cls-150{fill:#0f1215;}.cls-151{fill:#0d1113;}.cls-152{fill:#0b0f11;}.cls-153{opacity:0;}.cls-154{opacity:0.06;}.cls-155{opacity:0.13;}.cls-156{opacity:0.19;}.cls-157{opacity:0.25;}.cls-158{opacity:0.31;}.cls-159{opacity:0.38;}.cls-160{opacity:0.44;}.cls-161,.cls-217{opacity:0.5;}.cls-162{opacity:0.56;}.cls-163{opacity:0.63;}.cls-164{opacity:0.69;}.cls-165{opacity:0.75;}.cls-166{opacity:0.81;}.cls-167{opacity:0.88;}.cls-168{opacity:0.94;}.cls-170{fill:#818186;}.cls-171{fill:#848489;}.cls-172{fill:#8b8b91;}.cls-173{fill:#8e8e94;}.cls-174{fill:#909097;}.cls-175{fill:#93939a;}.cls-176{fill:#95959c;}.cls-177{fill:#98989f;}.cls-178{fill:#9a9aa2;}.cls-179{fill:url(#radial-gradient-28);}.cls-180{fill:url(#linear-gradient-57);}.cls-181{fill:url(#radial-gradient-29);}.cls-182{fill:url(#linear-gradient-58);}.cls-184{fill:#f1f1f1;}.cls-185{fill:#e4e4e4;}.cls-186{fill:#d6d6d6;}.cls-187{fill:#c8c8c8;}.cls-188{fill:#bbb;}.cls-189{fill:#adadad;}.cls-190{fill:#a0a0a0;}.cls-191{fill:#929292;}.cls-192{fill:#848484;}.cls-193{fill:#777;}.cls-194{fill:#696969;}.cls-195{fill:#b74700;}.cls-196{fill:#b94a00;}.cls-197{fill:#bb4d00;}.cls-198{fill:#bc5000;}.cls-199{fill:#be5300;}.cls-200{fill:#c05600;}.cls-201{fill:#c25900;}.cls-202{fill:#c45c00;}.cls-203{fill:#c55f00;}.cls-204{fill:#c76200;}.cls-205{fill:#c96500;}.cls-206{fill:#cb6800;}.cls-207{fill:#cd6b00;}.cls-208{fill:#cf6e00;}.cls-209{fill:#d07100;}.cls-210{fill:#d27400;}.cls-211{fill:#d47700;}.cls-212{fill:#d67a00;}.cls-213{fill:#d87d00;}.cls-214{fill:#d98000;}.cls-215{fill:#db8300;}.cls-216{fill:#dd8600;}.cls-218{fill:url(#linear-gradient-59);}.cls-219{fill:#637771;}.cls-220,.cls-223,.cls-224,.cls-226{mix-blend-mode:hard-light;}.cls-220{fill:url(#linear-gradient-60);}.cls-221{fill:url(#linear-gradient-61);}.cls-222{fill:url(#linear-gradient-62);}.cls-223{fill:url(#linear-gradient-63);}.cls-224{fill:url(#linear-gradient-64);}.cls-225{fill:url(#linear-gradient-65);}.cls-226{fill:url(#linear-gradient-66);}.cls-227{fill:url(#linear-gradient-67);}.cls-228{fill:url(#linear-gradient-68);}.cls-229{fill:url(#linear-gradient-69);}.cls-230{fill:url(#linear-gradient-70);}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 257.05,
    cy: -222.19,
    r: 22.68,
    gradientTransform: "matrix(-7.98, 0, 0, 0.54, 2231.48, 248.41)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#babbb9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#bfc0be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#cdcecc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#e4e5e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 4188.55,
    cy: -929.72,
    r: 22.67,
    gradientTransform: "matrix(-1, 0, 0, 0.26, 4477.59, 373.97)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#121411"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#313230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#6e706e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#a2a3a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#cacbca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 4198.75,
    cy: -956.42,
    r: 22.67,
    gradientTransform: "matrix(-1, 0, 0, 0.26, 4477.59, 373.97)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#343633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#6f706e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#a2a3a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#cacbca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 4378.25,
    cy: -928.74,
    r: 22.67,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 4369.69,
    cy: -945.43,
    r: 22.67,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: -6120.77,
    cy: 107.86,
    r: 17.78,
    gradientTransform: "translate(6402.53)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#050503"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#030302"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: -6120.77,
    cy: 107.86,
    r: 18.12,
    gradientTransform: "translate(6402.53)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#020200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#050503"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#10100f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#161615"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: -6120.77,
    cy: 107.86,
    r: 12.59,
    gradientTransform: "translate(6402.53)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#d9d9d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#d6d6d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#cbcbca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#b9b9b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#a0a09e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#828280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#80807e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#787876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#6b6b69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#595957"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#4f4f4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#545452"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#60605f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#646463"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#0c0c0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#131311"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#252523"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: -6236.56,
    cy: 120.15,
    r: 21.95,
    gradientTransform: "translate(6524.16)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#090908"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#191918"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: -6230.44,
    cy: 2201.68,
    r: 18.5,
    gradientTransform: "translate(6229.49 3004.68) rotate(45.43)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#2b2b29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#292927"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#222221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#171715"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-11",
    cx: -6230.44,
    cy: 2201.68,
    r: 18.5,
    gradientTransform: "translate(6896.31 165.6) rotate(19.93)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#151515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#282826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#2b2b29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#363635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-12",
    cx: -6352.07,
    cy: 2201.69,
    r: 12.51,
    gradientTransform: "translate(7010.66 207.06) rotate(19.93)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#b3b3b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#b0b0ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#a5a5a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#939392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#7a7a78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#5c5c5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#5a5a58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#525250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#454543"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#333331"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#292927"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#2e2e2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#3a3a39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#3e3e3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-13",
    cx: -6352.07,
    cy: 2201.69,
    r: 12.84,
    gradientTransform: "translate(7010.66 207.06) rotate(19.93)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2a2a29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#636362"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#787877"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#80807f"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-14",
    cx: -6352.07,
    cy: 2201.69,
    r: 13.76,
    gradientTransform: "translate(7010.66 207.06) rotate(19.93)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3b3b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "silver"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#b9b9b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#a5a5a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#a9a9a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#c5c5c4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 2793.73,
    y1: -760.04,
    x2: 2795.8,
    y2: -760.04,
    gradientTransform: "translate(3173.9 352.65) rotate(-160.07)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#50575c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10100f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 2794.05,
    y1: -760.04,
    x2: 2795.48,
    y2: -760.04,
    gradientTransform: "translate(3173.9 352.65) rotate(-160.07)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#10100f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50575c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 2790.65,
    y1: -757.8,
    x2: 2792.73,
    y2: -757.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 2790.97,
    y1: -757.8,
    x2: 2792.4,
    y2: -757.8,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 2791.82,
    y1: -754.18,
    x2: 2793.9,
    y2: -754.18,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 2792.14,
    y1: -754.18,
    x2: 2793.58,
    y2: -754.18,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 2795.63,
    y1: -754.18,
    x2: 2797.71,
    y2: -754.18,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 2795.95,
    y1: -754.18,
    x2: 2797.39,
    y2: -754.18,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 2796.8,
    y1: -757.8,
    x2: 2798.88,
    y2: -757.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 2797.13,
    y1: -757.8,
    x2: 2798.56,
    y2: -757.8,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-15",
    cx: -6352.09,
    cy: 2201.58,
    r: 1.43,
    gradientTransform: "translate(7010.66 207.06) rotate(19.93)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3b3b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "silver"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#b9b9b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a5a5a4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -6237.04,
    y1: 91.22,
    x2: -6237.04,
    y2: 107.58,
    gradientTransform: "translate(6524.16)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a5a57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#6e6e6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#8a8a89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#a0a09f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#b0b0af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#b9b9b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#bcbcbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#c1c1c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-16",
    cx: -6300.63,
    cy: 107.56,
    r: 17.78,
    xlinkHref: "#radial-gradient-6"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-17",
    cx: -6300.63,
    cy: 107.56,
    r: 18.12,
    xlinkHref: "#radial-gradient-7"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-18",
    cx: -6300.63,
    cy: 107.56,
    r: 12.59,
    xlinkHref: "#radial-gradient-8"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-19",
    cx: -6431.97,
    cy: 119.01,
    r: 21.95,
    xlinkHref: "#radial-gradient-9"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-20",
    cx: -6411.75,
    cy: 2267.43,
    r: 18.5,
    gradientTransform: "translate(6896.31 165.6) rotate(19.93)",
    xlinkHref: "#radial-gradient-10"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-21",
    cx: -6411.75,
    cy: 2267.43,
    r: 18.5,
    xlinkHref: "#radial-gradient-11"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-22",
    cx: -6533.39,
    cy: 2267.44,
    r: 12.51,
    xlinkHref: "#radial-gradient-12"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-23",
    cx: -6533.39,
    cy: 2267.44,
    r: 12.85,
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-24",
    cx: -6533.39,
    cy: 2267.44,
    r: 13.76,
    xlinkHref: "#radial-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 2975.04,
    y1: -825.78,
    x2: 2977.12,
    y2: -825.78,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 2975.36,
    y1: -825.78,
    x2: 2976.79,
    y2: -825.78,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 2971.96,
    y1: -823.55,
    x2: 2974.04,
    y2: -823.55,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 2972.28,
    y1: -823.55,
    x2: 2973.71,
    y2: -823.55,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 2973.13,
    y1: -819.93,
    x2: 2975.21,
    y2: -819.93,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 2973.46,
    y1: -819.93,
    x2: 2974.89,
    y2: -819.93,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 2976.94,
    y1: -819.93,
    x2: 2979.02,
    y2: -819.93,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 2977.26,
    y1: -819.93,
    x2: 2978.7,
    y2: -819.93,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 2978.12,
    y1: -823.55,
    x2: 2980.2,
    y2: -823.55,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 2978.44,
    y1: -823.55,
    x2: 2979.87,
    y2: -823.55,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-25",
    cx: -6533.4,
    cy: 2267.32,
    r: 1.43,
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -6427.91,
    y1: 93.53,
    x2: -6427.91,
    y2: 109.23,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-26",
    cx: -6367,
    cy: 117.72,
    r: 31.54,
    xlinkHref: "#radial-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 9106.65,
    y1: 113.65,
    x2: 9110.21,
    y2: 113.65,
    gradientTransform: "matrix(-1, 0, 0, 1, 9176.92, 0)",
    xlinkHref: "#radial-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 8910.06,
    y1: 114.58,
    x2: 8913.62,
    y2: 114.58,
    gradientTransform: "matrix(-1, 0, 0, 1, 9176.92, 0)",
    xlinkHref: "#radial-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: -6345.43,
    y1: 114.95,
    x2: -6345.43,
    y2: -0.47,
    gradientTransform: "translate(6524.16)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#93938e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9e9f9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#acafab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#b4b8b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#b7bbb7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#babeba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#cdcfcc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#d8d9d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#dcdcdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#e0e0df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#e0e2e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#e0e3e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#d6d7d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#cacac9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: -6347.43,
    y1: 114.88,
    x2: -6347.43,
    y2: 76.43,
    gradientTransform: "translate(6524.16)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1dbe2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#efecf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#fbfafb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-27",
    cx: -6236.94,
    cy: 110.87,
    r: 39.27,
    gradientTransform: "translate(6524.16)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aeafaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#d9dada"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: -6192.04,
    y1: 84.73,
    x2: -6200.58,
    y2: 84.73,
    gradientTransform: "translate(6524.16)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bac7bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#c0ccc3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#e2e8e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#f7f9f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: -6281.91,
    y1: 115.89,
    x2: -6281.91,
    y2: 112.98,
    gradientTransform: "translate(6524.16)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#444443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#9d9d9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: -6217.35,
    y1: 102.95,
    x2: -6191.2,
    y2: 103.45,
    gradientTransform: "translate(6524.16)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#0c0f10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#1d2527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#2e3536"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#5c5e5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#727271"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#707170"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#6b706f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#616563"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#464644"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: -6200.56,
    y1: 113.53,
    x2: -6200.56,
    y2: 106.79,
    gradientTransform: "translate(6524.16)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a5a57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#5c5c59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#8e8e8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#b6b6b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#d6d6d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#ededec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#fafafa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: -6217.17,
    y1: 93.37,
    x2: -6191.33,
    y2: 93.86,
    gradientTransform: "translate(6524.16)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#959393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#999797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#a6a4a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#bbbaba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#d8d8d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#e7e7e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#e7e7e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5e5e4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: -6499.03,
    y1: 57.78,
    x2: -6493.87,
    y2: 57.68,
    gradientTransform: "translate(6524.16)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#93927e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#aeae9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#cbcbc1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#e2e2dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#f2f2f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#fcfcfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: -6355.62,
    y1: 114.79,
    x2: -6355.62,
    y2: 112.87,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: -6471.74,
    y1: 114.34,
    x2: -6471.74,
    y2: 112.7,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: -6490.96,
    y1: 112.87,
    x2: -6490.58,
    y2: 95.66,
    gradientTransform: "translate(6524.16)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#444443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#9d9d9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: -6490.7,
    y1: 96.99,
    x2: -6490.7,
    y2: 95.22,
    gradientTransform: "translate(6524.16)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#9aa2a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#bfc4c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#e2e4e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#f7f8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: -6498.94,
    y1: 103.28,
    x2: -6497.58,
    y2: 103.28,
    gradientTransform: "translate(6524.16)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#89928f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#a4aba9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#cbcfce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#e8e9e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: -6214.62,
    y1: 77.92,
    x2: -6214.62,
    y2: 54.92,
    gradientTransform: "translate(6524.16)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bac7bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#c0ccc3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#d2dbd4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#f0f3f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 5267.91,
    y1: 467.72,
    x2: 5285.07,
    y2: 467.72,
    gradientTransform: "matrix(-1.04, -0.06, -0.05, 0.92, 5819.63, -36.65)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#d9d9d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#d6d6d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#cbcbca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#b9b9b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#a0a09e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#828280"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 5267.5,
    y1: 463.63,
    x2: 5282.83,
    y2: 470.31,
    gradientTransform: "matrix(-1.04, -0.06, -0.05, 0.92, 5819.63, -36.65)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#d9d9d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#d6d6d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#cbcbca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#b9b9b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#a0a09e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#80807d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5a5a57"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 5146.34,
    y1: 467.6,
    x2: 5163.43,
    y2: 467.6,
    gradientTransform: "matrix(-1.04, -0.06, -0.05, 0.92, 5693.52, -43.92)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1d1d1b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 5151.69,
    y1: 470.51,
    x2: 5153.49,
    y2: 470.51,
    gradientTransform: "matrix(-1.04, -0.06, -0.05, 0.92, 5693.52, -43.92)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 5152.59,
    y1: 470.35,
    x2: 5161.53,
    y2: 470.35,
    xlinkHref: "#linear-gradient-43"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: -4625.86,
    y1: 473.85,
    x2: -4623.44,
    y2: 469.77,
    gradientTransform: "matrix(1.04, 0.06, -0.05, 0.92, 5148.61, -76)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b5bfbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: -4637.62,
    y1: 468.08,
    x2: -4621.12,
    y2: 468.08,
    gradientTransform: "matrix(1.04, 0.06, -0.05, 0.92, 5148.61, -76)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: -3966.27,
    y1: 72.22,
    x2: -3961.61,
    y2: 72.22,
    gradientTransform: "translate(3992.32)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#878787"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: -3966.27,
    y1: 78.63,
    x2: -3961.61,
    y2: 78.63,
    xlinkHref: "#linear-gradient-47"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: -3966.27,
    y1: 85.03,
    x2: -3961.61,
    y2: 85.03,
    xlinkHref: "#linear-gradient-47"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 4631.01,
    y1: 78.71,
    x2: 4634.38,
    y2: 78.71,
    gradientTransform: "matrix(1, 0, 0, -1, -4606.44, 157.42)",
    xlinkHref: "#linear-gradient-43"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: -6333.13,
    y1: 103.61,
    x2: -6333.13,
    y2: 98.95,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 13180.6,
    y1: 103.61,
    x2: 13180.6,
    y2: 98.95,
    gradientTransform: "matrix(-1, 0, 0, 1, 13239.08, 0)",
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: -6255.85,
    y1: 116.56,
    x2: -6210.05,
    y2: 90.22,
    gradientTransform: "translate(6524.16)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#0c0f10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#1d2527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#2e3536"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#5c5e5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#727271"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#454543"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#30302e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: -6297.26,
    y1: 40.79,
    x2: -6247.33,
    y2: 40.79,
    gradientTransform: "translate(6524.16)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#637771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93a19d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: -6271.15,
    y1: 41.21,
    x2: -6270.85,
    y2: 41.21,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 10070.85,
    y1: 41.58,
    x2: 10071.15,
    y2: 41.58,
    gradientTransform: "matrix(-1, 0, 0, 1, 10325.2, 0)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-28",
    cx: 5397.4,
    cy: 67.36,
    r: 4.92,
    gradientTransform: "matrix(-1, 0, 0, 1, 5628.92, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 5396.76,
    y1: 68.35,
    x2: 5396.76,
    y2: 66.42,
    gradientTransform: "matrix(-1, 0, 0, 1, 5628.92, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#292929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#0b0b0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#171716"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#282826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#2b2b29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#363635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-29",
    cx: 5430.89,
    cy: 67.36,
    r: 4.92,
    xlinkHref: "#radial-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 5430.25,
    y1: 68.35,
    x2: 5430.25,
    y2: 66.42,
    xlinkHref: "#linear-gradient-57"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: -6384.04,
    y1: 19.83,
    x2: -6384.04,
    y2: 18.34,
    gradientTransform: "translate(6524.16)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#444443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#9d9d9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 1057.37,
    y1: -3289.83,
    x2: 1057.37,
    y2: -3290.58,
    gradientTransform: "translate(3504.69 1115.13) rotate(-90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7e8183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#898c8d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#a7a8a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c8c8c7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 1057.4,
    y1: -3290.6,
    x2: 1057.4,
    y2: -3291.35,
    gradientTransform: "translate(3504.69 1115.13) rotate(-90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aeb4b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#b7bcbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#b9bebe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#d3d6d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#e6e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#f4f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 85.11,
    y1: 66.23,
    x2: 85.11,
    y2: 63.9,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 85.11,
    y1: 73.18,
    x2: 85.11,
    y2: 70.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7e8183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#808385"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#898b8d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#97999a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#abacac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#c5c5c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c8c8c7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 1057.78,
    y1: -3375.23,
    x2: 1057.78,
    y2: -3375.98,
    xlinkHref: "#linear-gradient-60"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 1057.78,
    y1: -3376,
    x2: 1057.78,
    y2: -3376.74,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 1057.93,
    y1: -3462.37,
    x2: 1057.93,
    y2: -3463.12,
    gradientTransform: "translate(-1015.99 3519.95)",
    xlinkHref: "#linear-gradient-60"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 1057.93,
    y1: -3463.14,
    x2: 1057.93,
    y2: -3463.88,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 85.69,
    y1: 67.09,
    x2: 85.69,
    y2: 69.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9c9c9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#b4b4b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#cfcfce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#dfdfde"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#e5e5e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#d6d6d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#b6b6b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#a3a3a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#9c9c9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#b0b3b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#b7bbb7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#b0b4b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#9ea19b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#7f817a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#55554c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#515148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#54544b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#5d5d55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#6d6d66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#82827e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c9c9a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 43.38,
    y1: 66.14,
    x2: 43.38,
    y2: 70.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#9d9d9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#444443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 126.85,
    y1: 66.14,
    x2: 126.85,
    y2: 70.36,
    xlinkHref: "#linear-gradient-69"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 180.89,
    cy: 129.18,
    rx: 180.89,
    ry: 12.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M266.37,128.61c0,3.31,10.15,6,22.67,6s22.68-2.68,22.68-6-10.16-6-22.68-6S266.37,125.31,266.37,128.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M256.17,121.57c0,3.3,10.15,6,22.67,6s22.68-2.68,22.68-6-10.16-6-22.68-6S256.17,118.26,256.17,121.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M76.66,128.87c0,3.31,10.15,6,22.67,6s22.68-2.67,22.68-6-10.15-6-22.68-6S76.66,125.57,76.66,128.87Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 107.9,
    cy: 124.47,
    rx: 22.67,
    ry: 5.98
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M281.76,90.09a17.78,17.78,0,1,0,17.77,17.77A17.78,17.78,0,0,0,281.76,90.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M297.46,106.15l2.35-.27-.41-2.33-2.32.55c-.05-.22-.1-.44-.16-.65l2.27-.67-.81-2.23-2.18.94c-.09-.2-.19-.4-.29-.6L298,99.83l-1.18-2-2,1.3c-.12-.19-.26-.36-.4-.54l1.92-1.42-1.52-1.81-1.73,1.63c-.16-.16-.31-.32-.48-.47l1.64-1.73-1.81-1.52-1.42,1.91-.55-.4,1.31-2-2-1.18-1.07,2.12-.6-.29.95-2.17-2.23-.81-.68,2.27-.65-.16.56-2.32-2.33-.41-.28,2.35-.66,0,.14-2.38h-2.37l.15,2.38-.67,0-.28-2.35-2.33.41.56,2.32-.65.16-.68-2.27-2.23.81.95,2.17-.6.29-1.07-2.12-2.05,1.18,1.31,2-.55.4L271,93.22l-1.81,1.52,1.64,1.73-.48.47-1.73-1.63-1.52,1.81L269,98.54c-.14.18-.28.35-.4.54l-2-1.3-1.18,2,2.13,1.06c-.1.2-.2.4-.29.6l-2.18-.94-.81,2.23,2.28.67c-.07.21-.12.43-.17.65l-2.32-.55-.41,2.33,2.35.27c0,.22,0,.45,0,.67l-2.38-.14v2.37l2.38-.15c0,.22,0,.45,0,.67l-2.35.28.41,2.33,2.32-.56c.05.22.1.44.16.65l-2.27.68.81,2.23,2.17-1c.09.2.2.4.29.6l-2.12,1.07,1.18,2,2-1.31c.13.19.27.36.4.55l-1.91,1.42,1.52,1.81,1.73-1.64.47.48L269.2,121l1.81,1.52,1.42-1.92c.18.14.35.28.54.4l-1.3,2,2.05,1.18,1.06-2.13.6.29-.94,2.18,2.23.81.67-2.28c.22.07.43.12.65.17l-.55,2.32,2.33.41.27-2.35.68,0-.15,2.38h2.37l-.14-2.38.67,0,.27,2.35,2.33-.41-.55-2.32c.22,0,.44-.1.65-.17l.67,2.28,2.23-.81-.94-2.18.6-.29,1.06,2.13,2-1.18-1.3-2c.19-.12.36-.26.54-.4l1.42,1.92,1.81-1.52-1.63-1.73c.16-.16.32-.31.47-.48l1.73,1.64,1.52-1.81-1.91-1.42c.13-.19.27-.36.4-.55l2,1.31,1.18-2-2.12-1.07c.09-.2.2-.4.29-.6l2.17,1,.81-2.23-2.27-.68c.06-.21.11-.43.16-.65l2.32.56.41-2.33-2.35-.28c0-.22,0-.45,0-.67l2.38.15v-2.37l-2.38.14C297.48,106.6,297.48,106.37,297.46,106.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M281.76,95.27a12.6,12.6,0,1,0,12.59,12.59A12.6,12.6,0,0,0,281.76,95.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M261.39,110.83l1.29,2.48a4.31,4.31,0,0,0,4.16,2.33l47.73-3.55-5.82-24.47-37.14-3.81Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 288.52,
    cy: 111.45,
    r: 18.5,
    transform: "translate(-19.87 135.05) rotate(-25.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M304.18,115.26l2.36.57.41-2.38-2.41-.28c0-.23,0-.46.06-.68l2.42.14v-2.41l-2.42.14c0-.23,0-.45-.07-.68l2.42-.28-.43-2.38-2.35.56c-.05-.22-.13-.44-.19-.66l2.33-.69-.83-2.27-2.23,1c-.09-.21-.19-.42-.29-.62l2.18-1.09-1.21-2.09-2,1.34c-.13-.19-.25-.38-.39-.57l1.95-1.44-1.56-1.85-1.76,1.67-.48-.49L301.32,98l-1.85-1.55L298,98.43l-.56-.39,1.34-2-2.1-1.21L295.62,97,295,96.7l1-2.23-2.27-.83L293,96c-.21-.07-.43-.14-.65-.19l.55-2.36L290.52,93l-.27,2.41c-.23,0-.45-.05-.68-.06l.14-2.42h-2.42l.15,2.42c-.23,0-.45,0-.68.07L286.48,93l-2.38.42.57,2.35L284,96l-.7-2.33-2.27.83,1,2.22-.62.29-1.09-2.17L278.21,96l1.34,2c-.19.13-.38.24-.57.38l-1.44-1.94-1.85,1.56,1.67,1.76c-.16.16-.33.31-.49.48l-1.76-1.66-1.55,1.85,1.95,1.44-.39.56-2-1.33-1.2,2.09,2.16,1.08c-.1.2-.18.42-.27.63l-2.24-1-.82,2.27,2.33.68c-.06.22-.13.44-.19.66l-2.35-.55-.42,2.38,2.42.27c0,.23-.05.45-.07.68l-2.42-.14v2.42l2.42-.15c0,.22,0,.45.07.68l-2.41.28.42,2.38,2.35-.57c.05.22.13.44.19.66l-2.33.7.83,2.27,2.22-1c.1.21.19.41.3.62l-2.17,1.09,1.21,2.09,2-1.34.38.57-1.93,1.44,1.55,1.85,1.76-1.68.48.5-1.66,1.76,1.85,1.55,1.44-2,.57.39-1.34,2,2.1,1.2,1.07-2.16c.21.1.43.18.64.27l-1,2.24,2.27.82.7-2.33.66.19-.57,2.35,2.38.42.28-2.42.68.07-.14,2.42h2.41l-.14-2.42.68-.07.28,2.41,2.38-.42-.56-2.35c.22,0,.43-.13.65-.19l.7,2.33,2.27-.83-1-2.23.62-.29,1.09,2.17,2.09-1.21-1.34-2,.57-.38,1.44,1.94,1.84-1.55-1.67-1.77c.17-.16.34-.31.5-.48l1.75,1.67,1.55-1.86L301.54,121c.13-.18.26-.38.38-.57l2,1.34,1.21-2.09L303,118.55c.1-.21.19-.42.28-.63l2.23,1,.83-2.27-2.34-.7C304.06,115.7,304.13,115.48,304.18,115.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M292.79,99.69a12.51,12.51,0,1,0,7.49,16A12.53,12.53,0,0,0,292.79,99.69Zm-8,22a10.84,10.84,0,1,1,13.88-6.5A10.86,10.86,0,0,1,284.83,121.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M300.79,115.08l.1.06.1-.82s0,0,0-.08a12.55,12.55,0,0,0,.19-4.31.13.13,0,0,1,0-.06l-.07-1.35-.17.08a12.79,12.79,0,0,0-5.25-7.6l.21-.19-3-1.39h0l-3.21-.85s0,.11,0,.31a12.84,12.84,0,0,0-8.85,2.56l-.14-.3-2.25,2.44h0l-1.8,2.79.27,0c-.11.26-.22.53-.32.8a12.64,12.64,0,0,0-.08,8.43l-.19,0,.69,1.24,0,0a12.05,12.05,0,0,0,.9,1.61h0l0,0a12.28,12.28,0,0,0,1.51,1.86l.05.06.5.62.06-.1a12.65,12.65,0,0,0,8.71,3.23l0,0,.27,0,.13,0a12.82,12.82,0,0,0,5.59-1.61l.12-.06.26-.1,0,0a12.67,12.67,0,0,0,5.4-6.56C300.63,115.62,300.71,115.35,300.79,115.08Zm-.49-7.2a1,1,0,0,1-.63,1.23,12.81,12.81,0,0,1-3.22.63c-.6,0-1.34.07-2.11.1a2.31,2.31,0,0,1-2.19-3.23c.31-.71.62-1.39.88-1.94a13.19,13.19,0,0,1,1.74-2.69,1,1,0,0,1,1.36-.13A12.31,12.31,0,0,1,300.3,107.88Zm-11.49-8.63a1,1,0,0,1,1,1,13,13,0,0,1-.39,3.13c-.15.59-.35,1.3-.56,2a2.31,2.31,0,0,1-3.75,1.08c-.58-.51-1.13-1-1.57-1.43a13,13,0,0,1-2-2.43,1,1,0,0,1,.29-1.35A12.36,12.36,0,0,1,288.81,99.25Zm-11.8,8.1h0a1,1,0,0,1,1.22-.59,13.13,13.13,0,0,1,2.91,1.36c.51.32,1.13.73,1.77,1.16a2.31,2.31,0,0,1-.13,3.9c-.67.39-1.32.76-1.85,1a13.18,13.18,0,0,1-3.06,1.17,1,1,0,0,1-1.19-.71A12.21,12.21,0,0,1,277,107.35Zm7.37,15.76a11.93,11.93,0,0,1-3.36-1.86,1,1,0,0,1-.2-1.34,12.78,12.78,0,0,1,2.28-2.49c.47-.39,1-.85,1.66-1.32a2.3,2.3,0,0,1,3.66,1.33c.17.76.32,1.48.43,2.08a13.09,13.09,0,0,1,.16,3.43,1,1,0,0,1-1,.89A12.38,12.38,0,0,1,284.38,123.11Zm8.19-4.68c-.23-.56-.48-1.25-.75-2a2.32,2.32,0,0,1,2.41-3.09c.77.08,1.5.16,2.1.24a12.9,12.9,0,0,1,3.25.89,1,1,0,0,1,.56,1.23h0a12.22,12.22,0,0,1-4.52,5.89,1,1,0,0,1-1.35-.21A12.74,12.74,0,0,1,292.57,118.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M293.63,98.67a13.76,13.76,0,1,0,8,17A13.76,13.76,0,0,0,293.63,98.67Zm7.21,10.62a.75.75,0,0,1-.55.84,32.42,32.42,0,0,1-7.43.7c-.36,0-1,0-1.75,0a1.29,1.29,0,0,1-1.18-1.75c.24-.66.48-1.29.62-1.62a33.16,33.16,0,0,1,3.35-6.55.74.74,0,0,1,1-.21A12.58,12.58,0,0,1,300.84,109.29Zm-12.36,2Zm1.9-12.24a.73.73,0,0,1,.62.78,33.28,33.28,0,0,1-1.63,7.14c-.1.35-.33,1-.56,1.65a1.3,1.3,0,0,1-2,.59l-1.36-1.09a33.77,33.77,0,0,1-5.17-5.18.74.74,0,0,1,.11-1A12.55,12.55,0,0,1,290.38,99.08Zm-13.62,8.1a12.13,12.13,0,0,1,.65-1.47.73.73,0,0,1,.93-.34,33.75,33.75,0,0,1,6.32,3.77c.29.2.83.61,1.39,1a1.31,1.31,0,0,1-.07,2.12l-1.45,1a33.36,33.36,0,0,1-6.67,3.36.74.74,0,0,1-.91-.42A12.47,12.47,0,0,1,276.76,107.18Zm2.87,13.06a.72.72,0,0,1,0-1,32.59,32.59,0,0,1,5.64-5c.29-.21.84-.6,1.43-1a1.29,1.29,0,0,1,2,.72c.19.68.37,1.33.46,1.68a32.15,32.15,0,0,1,1.13,7.5.73.73,0,0,1-.67.73,12.48,12.48,0,0,1-5.3-.7A12.34,12.34,0,0,1,279.63,120.24Zm14.65,2.31a.75.75,0,0,1-1-.27,32.29,32.29,0,0,1-3-7c-.12-.34-.32-1-.52-1.67a1.31,1.31,0,0,1,1.3-1.67c.71,0,1.38.06,1.74.09a32,32,0,0,1,7.42,1.22.72.72,0,0,1,.49.85,11.44,11.44,0,0,1-.45,1.56A12.48,12.48,0,0,1,294.28,122.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M286.47,114.07a1,1,0,1,1,.62,1.33A1,1,0,0,1,286.47,114.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M287.69,113.75a.72.72,0,1,1-.92.43A.72.72,0,0,1,287.69,113.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M290.46,114.19a1,1,0,1,1,1.46-.18A1,1,0,0,1,290.46,114.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M290.53,112.93a.72.72,0,1,1,.13,1A.73.73,0,0,1,290.53,112.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M291.81,110.43a1,1,0,1,1,.28-1.45A1,1,0,0,1,291.81,110.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M290.63,110a.72.72,0,1,1,1,.19A.72.72,0,0,1,290.63,110Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M288.65,108a1,1,0,1,1-1.29-.71A1,1,0,0,1,288.65,108Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M287.85,109a.72.72,0,1,1,.49-.89A.72.72,0,0,1,287.85,109Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M285.35,110.23a1,1,0,1,1-1.08,1A1,1,0,0,1,285.35,110.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M286,111.29a.72.72,0,1,1-.7-.74A.73.73,0,0,1,286,111.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M289.9,111.83A1.44,1.44,0,1,1,289,110,1.44,1.44,0,0,1,289.9,111.83Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 262.47,
    y: 89.27,
    width: 49.29,
    height: 18.68
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-28",
    cx: 101.9,
    cy: 107.56,
    r: 17.78
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M117.6,105.85l2.35-.27-.41-2.33-2.32.55c0-.22-.1-.44-.16-.65l2.27-.67-.81-2.23-2.17.94-.3-.6,2.13-1.06-1.18-2-2,1.3c-.12-.19-.26-.36-.4-.55l1.92-1.41L115,95l-1.73,1.63c-.16-.16-.31-.32-.48-.48l1.64-1.72-1.81-1.52-1.42,1.91-.54-.4,1.3-2-2-1.19-1.06,2.13-.61-.29.95-2.17L107,90.13l-.68,2.27-.65-.17.56-2.31-2.33-.41-.28,2.35-.66,0,.14-2.38h-2.37l.15,2.38-.67,0-.27-2.35-2.34.41.56,2.31-.65.17-.68-2.27-2.22.81.94,2.17-.6.29-1.07-2.13-2,1.19,1.31,2c-.19.13-.36.27-.54.4l-1.43-1.91-1.81,1.52L91,96.16l-.48.48L88.77,95l-1.52,1.81,1.92,1.41c-.13.19-.28.36-.4.55l-2-1.3-1.18,2,2.13,1.06c-.1.2-.2.4-.29.6l-2.18-.94-.81,2.23,2.28.67c-.07.21-.12.43-.17.65l-2.32-.55-.41,2.33,2.36.27c0,.22,0,.44,0,.67l-2.38-.14v2.37l2.38-.15c0,.22,0,.45,0,.67l-2.36.27.41,2.34,2.32-.56c.05.22.1.43.16.65l-2.27.68.81,2.22,2.17-.94c.09.2.2.4.3.6l-2.13,1.07,1.18,2.05,2-1.31c.13.19.27.36.4.54l-1.91,1.43,1.52,1.81,1.73-1.64L91,119l-1.63,1.73,1.81,1.52,1.42-1.92c.18.13.35.28.54.4l-1.3,2,2,1.18,1.06-2.13.61.29-.94,2.18,2.22.81.67-2.28.65.17-.55,2.32,2.34.41.26-2.36c.23,0,.45,0,.68,0l-.15,2.38h2.37l-.14-2.38c.23,0,.45,0,.67,0l.27,2.36,2.33-.41-.55-2.32.65-.17L107,125l2.23-.81-.94-2.18.6-.29,1.06,2.13,2-1.18-1.3-2c.19-.12.36-.27.54-.4l1.42,1.92,1.81-1.52L112.82,119l.48-.48,1.72,1.64,1.52-1.81-1.91-1.43c.13-.18.27-.35.4-.54l2,1.31,1.18-2.05-2.12-1.07c.1-.2.2-.4.29-.6l2.17.94.81-2.22-2.27-.68.17-.65,2.31.56.41-2.34-2.35-.27c0-.22,0-.45,0-.67l2.38.15v-2.37l-2.38.14C117.63,106.29,117.62,106.07,117.6,105.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M101.9,95a12.6,12.6,0,1,0,12.59,12.59A12.6,12.6,0,0,0,101.9,95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M66,109.69l1.28,2.48a4.34,4.34,0,0,0,4.17,2.33L119.16,111l-5.82-24.47L76.21,82.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M102,94.06a18.5,18.5,0,1,0,11.09,23.69A18.49,18.49,0,0,0,102,94.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M111.32,115.26l2.35.57.42-2.38-2.42-.28c0-.23,0-.46.07-.68l2.42.14v-2.41l-2.42.14c0-.23,0-.45-.07-.68l2.41-.28-.42-2.38-2.35.56c-.06-.22-.13-.44-.19-.66l2.33-.69-.83-2.27-2.23,1c-.09-.21-.19-.42-.29-.62l2.17-1.09-1.21-2.09-2,1.34c-.13-.19-.24-.38-.38-.57l1.94-1.44L109,98.61l-1.77,1.67c-.16-.16-.31-.33-.48-.49L108.46,98l-1.86-1.55-1.44,1.94-.57-.39,1.34-2-2.09-1.21L102.76,97l-.62-.27,1-2.23-2.27-.83L100.14,96c-.22-.07-.44-.14-.66-.19l.56-2.36L97.66,93l-.27,2.41c-.23,0-.46-.05-.69-.06L96.84,93H94.43l.15,2.42c-.23,0-.46,0-.68.07L93.61,93l-2.38.42.57,2.35-.66.2-.7-2.33-2.27.83,1,2.22-.62.29-1.1-2.17L85.34,96l1.35,2c-.19.13-.39.24-.57.38l-1.45-1.94-1.85,1.56,1.68,1.76c-.16.16-.33.31-.49.48l-1.76-1.66L80.7,100.5l2,1.44c-.14.18-.26.37-.39.56l-2-1.33L79,103.26l2.17,1.08c-.1.2-.18.42-.28.63l-2.23-1-.83,2.27,2.34.68c-.06.22-.14.44-.19.66l-2.36-.55-.41,2.38,2.41.27c0,.23,0,.45-.06.68l-2.42-.14v2.42l2.42-.15c0,.22,0,.45.07.68l-2.42.28.42,2.38L80,115.3c.06.22.13.44.2.66l-2.33.7.83,2.27,2.22-1c.09.21.19.41.29.62L79,119.67l1.21,2.09,2-1.34c.13.19.24.38.38.57l-1.94,1.44,1.56,1.85L84,122.6c.16.17.31.34.48.5l-1.66,1.76,1.85,1.55,1.44-2,.56.38-1.33,2,2.09,1.2,1.08-2.16c.21.1.42.18.64.27l-1,2.24,2.27.82.69-2.33.66.19-.56,2.35,2.38.42.28-2.42.68.07L94.47,130h2.42l-.15-2.42.69-.07.27,2.41,2.38-.42-.56-2.35.66-.19.69,2.33,2.27-.83-1-2.23.62-.29,1.08,2.17,2.09-1.21-1.34-2,.57-.38,1.44,1.94,1.85-1.55-1.67-1.77c.17-.16.33-.31.49-.48l1.76,1.67,1.55-1.86-2-1.44c.14-.18.26-.38.39-.57l2,1.34,1.2-2.09-2.16-1.08c.1-.21.18-.42.27-.63l2.24,1,.82-2.27-2.33-.7C111.19,115.7,111.27,115.48,111.32,115.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M99.92,99.69a12.51,12.51,0,1,0,7.5,16A12.52,12.52,0,0,0,99.92,99.69Zm-8,22a10.84,10.84,0,1,1,13.89-6.5A10.87,10.87,0,0,1,92,121.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M107.93,115.08l.1.06.1-.82a.22.22,0,0,1,0-.08,12.54,12.54,0,0,0,.18-4.31v-.06l-.08-1.35-.16.08a12.76,12.76,0,0,0-5.26-7.6l.21-.19-3-1.39h0l-3.22-.85s0,.11,0,.31A12.83,12.83,0,0,0,88,101.43l-.14-.3-2.26,2.44h0l-1.81,2.79.28,0c-.12.26-.23.53-.33.8a12.64,12.64,0,0,0-.07,8.43l-.2,0,.7,1.24a.17.17,0,0,1,0,0,14.79,14.79,0,0,0,.9,1.61h0l0,0a12.21,12.21,0,0,0,1.5,1.86l.06.06.5.62,0-.1A12.7,12.7,0,0,0,96,124.27v0l.26,0,.13,0a12.86,12.86,0,0,0,5.6-1.61l.11-.06.26-.1,0,0a12.69,12.69,0,0,0,5.41-6.56C107.76,115.62,107.85,115.35,107.93,115.08Zm-.49-7.2a1,1,0,0,1-.63,1.23,13,13,0,0,1-3.22.63c-.61,0-1.34.07-2.12.1a2.31,2.31,0,0,1-2.18-3.23c.31-.71.61-1.39.88-1.94a13.19,13.19,0,0,1,1.74-2.69,1,1,0,0,1,1.36-.13A12.31,12.31,0,0,1,107.44,107.88ZM96,99.25a1,1,0,0,1,1,1,13.5,13.5,0,0,1-.39,3.13c-.15.59-.35,1.3-.57,2a2.3,2.3,0,0,1-3.74,1.08c-.58-.51-1.13-1-1.57-1.43a13.08,13.08,0,0,1-2-2.43,1,1,0,0,1,.3-1.35A12.36,12.36,0,0,1,96,99.25Zm-11.81,8.1h0a1,1,0,0,1,1.22-.59,13.34,13.34,0,0,1,2.91,1.36c.51.32,1.12.73,1.76,1.16a2.31,2.31,0,0,1-.13,3.9c-.67.39-1.31.76-1.85,1A13,13,0,0,1,85,115.39a1,1,0,0,1-1.18-.71A12.29,12.29,0,0,1,84.14,107.35Zm7.37,15.76a12.07,12.07,0,0,1-3.36-1.86,1,1,0,0,1-.2-1.34,12.87,12.87,0,0,1,2.29-2.49c.46-.39,1-.85,1.65-1.32a2.31,2.31,0,0,1,3.67,1.33c.17.76.32,1.48.43,2.08a13,13,0,0,1,.15,3.43,1,1,0,0,1-1,.89A12.38,12.38,0,0,1,91.51,123.11Zm8.19-4.68c-.22-.56-.48-1.25-.74-2a2.32,2.32,0,0,1,2.4-3.09c.77.08,1.5.16,2.11.24a13.14,13.14,0,0,1,3.25.89,1,1,0,0,1,.55,1.23h0a12.28,12.28,0,0,1-4.52,5.89,1,1,0,0,1-1.36-.21A13.11,13.11,0,0,1,99.7,118.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M100.77,98.67a13.76,13.76,0,1,0,8,17A13.77,13.77,0,0,0,100.77,98.67Zm7.2,10.62a.73.73,0,0,1-.54.84,32.49,32.49,0,0,1-7.43.7c-.37,0-1,0-1.75,0a1.29,1.29,0,0,1-1.18-1.75c.24-.66.48-1.29.62-1.62a33.16,33.16,0,0,1,3.35-6.55.73.73,0,0,1,1-.21A12.52,12.52,0,0,1,108,109.29Zm-12.35,2Zm1.9-12.24a.73.73,0,0,1,.61.78A33.75,33.75,0,0,1,96.51,107c-.11.35-.33,1-.57,1.65a1.3,1.3,0,0,1-2,.59c-.55-.44-1.08-.86-1.35-1.09A33.31,33.31,0,0,1,87.39,103a.73.73,0,0,1,.11-1A12.54,12.54,0,0,1,97.52,99.08Zm-13.62,8.1a12.08,12.08,0,0,1,.64-1.47.74.74,0,0,1,.93-.34,33.44,33.44,0,0,1,6.32,3.77c.3.2.84.61,1.4,1a1.31,1.31,0,0,1-.07,2.12c-.59.39-1.15.76-1.46,1A33.6,33.6,0,0,1,85,116.61a.73.73,0,0,1-.91-.42A12.47,12.47,0,0,1,83.9,107.18Zm2.86,13.06a.72.72,0,0,1,0-1,32,32,0,0,1,5.63-5l1.43-1a1.3,1.3,0,0,1,2,.72c.19.68.37,1.33.45,1.68a31.74,31.74,0,0,1,1.14,7.5.74.74,0,0,1-.67.73,12.46,12.46,0,0,1-9.94-3.67Zm14.65,2.31a.74.74,0,0,1-1-.27,31.72,31.72,0,0,1-3-7c-.11-.34-.31-1-.51-1.67a1.31,1.31,0,0,1,1.3-1.67c.7,0,1.38.06,1.73.09a32,32,0,0,1,7.43,1.22.73.73,0,0,1,.49.85,13.08,13.08,0,0,1-.45,1.56A12.5,12.5,0,0,1,101.41,122.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M93.6,114.07a1,1,0,0,1,2,.71,1,1,0,0,1-2-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M94.82,113.75a.72.72,0,0,1-.49,1.35.73.73,0,0,1-.43-.92A.72.72,0,0,1,94.82,113.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M97.6,114.19a1,1,0,1,1,1.46-.18A1,1,0,0,1,97.6,114.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M97.67,112.93a.73.73,0,0,1,1-.13.72.72,0,0,1,.12,1,.72.72,0,1,1-1.13-.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M99,110.43a1,1,0,1,1,.28-1.45A1.05,1.05,0,0,1,99,110.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M97.77,110a.72.72,0,0,1,.19-1,.72.72,0,1,1,.81,1.19A.72.72,0,0,1,97.77,110Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M95.78,108a1,1,0,1,1-1.28-.71A1,1,0,0,1,95.78,108Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M95,109a.71.71,0,0,1-.88-.49.72.72,0,1,1,1.38-.4A.73.73,0,0,1,95,109Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M92.48,110.23a1,1,0,1,1-1.07,1A1,1,0,0,1,92.48,110.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M93.16,111.29a.72.72,0,0,1-.74.7.73.73,0,0,1-.69-.74.72.72,0,1,1,1.43,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M97,111.83a1.43,1.43,0,1,1-.86-1.84A1.43,1.43,0,0,1,97,111.83Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 71.6,
    y: 91.66,
    width: 49.29,
    height: 17.92
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M195.78,118.09H159.36l-2.81-1.79H140.37l-3.15,1.79H125.58a2.88,2.88,0,0,1-2.89-2.88v-1.34h76v1.34A2.88,2.88,0,0,1,195.78,118.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M66.71,106.48a52.86,52.86,0,0,1,.79,7.73c0,3.35-.79,8.79-.79,9.36,0,.3,1.78-1.53,2-2.43a36.65,36.65,0,0,0,1.46-7.49c.58-7.55-2.16-10-2.16-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M263.3,107.42a52.86,52.86,0,0,1,.79,7.73c0,3.35-.79,8.78-.79,9.36,0,.3,1.78-1.53,2-2.43a35.31,35.31,0,0,0,1.46-7.49c.58-7.55-2.16-10-2.16-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M329.22,76.27c-10.07-8.29-33.87-21-33.87-21l-1.75-.11s-29.3-29-38.94-38.74C244.24,5.89,231.26,0,200.47,0h0c-.61,0-1.22,0-5.47,0H38.91c-7.21,0-10,4.24-10.56,9.8C27.1,22.8,25.06,37.44,25,46.85c-.07,7.47.36,47.9.48,58.78A3.52,3.52,0,0,0,28.1,109l13.46,5.41,28.57.1,5.18-15.44a8,8,0,0,1,7.53-5.42h24.62A8,8,0,0,1,115,99.07l5.18,15.56,10.43,0,30.29.12,106.11.36V100.25c19-21.6,43-8.44,43,10.35v4.67l1.33-.81,18.34-4.11S336.29,82.09,329.22,76.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M26,107.43l15.59,7,28.57.1L75.35,99a7.89,7.89,0,0,1,7.48-5.39h24.66A7.89,7.89,0,0,1,115,99l5.19,15.62L267,115V100.25c19-21.6,43-8.44,43,10.35V115h.47l.86-.53,18.34-4.11s6.36-27.31-3.79-33.76H21.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M326.79,110.6a39.57,39.57,0,1,0-79.13,0,41.46,41.46,0,0,0,.25,4.48l19.09.06V100.25c19-21.6,43-8.44,43,10.35v4.67l1.33-.81L326.78,111C326.79,110.87,326.79,110.74,326.79,110.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M315.18,110.37a26.81,26.81,0,1,0-53.61.34V114h5v-3.27a21.84,21.84,0,1,1,43.68-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M323.36,93.3h8.94c.52-7.14.12-14.39-3.08-17l-.14-.11h-5.72Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 217.51,
    y: 112.95,
    width: 49.49,
    height: 3.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M332.52,93.65c-.3-2.19-25.07-1.34-25.77-.92a25.39,25.39,0,0,1,6.11,10.61,67.55,67.55,0,0,1,1.92,10.77s13.77-.55,16.52-3.13C333,109.36,332.77,95.43,332.52,93.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M315.62,93.12c-.24.9,1.65,14.43,3.92,16.69,1.74,1.74,8.87.54,10.17.54s3.85-11.26,2.51-16.72C331.85,92.12,316,91.73,315.62,93.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M316.23,93.18c-.21.86,1.74,13.33,3.83,15.43,1.62,1.63,8.27.7,9.49.7s3.68-10.66,2.41-15.66C331.6,92.23,316.56,91.83,316.23,93.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M316.84,93.23c-.19.82,1.83,12.23,3.75,14.18,1.49,1.52,7.66.85,8.8.85s3.51-10,2.31-14.59C331.34,92.34,317.14,91.94,316.84,93.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M317.46,93.28c-.17.78,1.9,11.14,3.65,12.93,1.37,1.41,7.07,1,8.11,1s3.35-9.43,2.22-13.53C331.09,92.44,317.72,92,317.46,93.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M318.07,93.34c-.14.73,2,10,3.57,11.67,1.24,1.3,6.46,1.16,7.42,1.16s3.18-8.82,2.12-12.46C330.84,92.55,318.31,92.14,318.07,93.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M318.69,93.39c-.13.7,2.08,8.94,3.47,10.42,1.12,1.19,5.86,1.32,6.74,1.32s3-8.21,2-11.4C330.58,92.65,318.89,92.24,318.69,93.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M319.3,93.44c-.1.66,2.17,7.85,3.39,9.17,1,1.08,5.25,1.47,6,1.47s2.83-7.59,1.92-10.33C330.32,92.76,319.47,92.34,319.3,93.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M319.91,93.49c-.08.62,2.26,6.75,3.3,7.92.87,1,4.66,1.62,5.36,1.62s2.64-7,1.82-9.26C330.07,92.86,320.05,92.44,319.91,93.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M320.53,93.55c-.06.57,2.33,5.65,3.21,6.66s4.05,1.78,4.67,1.78,2.44-6.36,1.72-8.2C329.81,93,320.63,92.54,320.53,93.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M321.14,93.6c0,.53,2.42,4.56,3.12,5.41a10.33,10.33,0,0,0,4,1.93c.54,0,2.24-5.73,1.63-7.13C329.54,93.08,321.21,92.65,321.14,93.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M321.76,93.65c0,.5,2.5,3.46,3,4.16a9.81,9.81,0,0,0,3.29,2.09c.45,0,2-5.11,1.53-6.07C329.27,93.19,321.79,92.75,321.76,93.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M322.37,93.7c0,.46,2.58,2.37,2.95,2.91a9.65,9.65,0,0,0,2.6,2.24c.36,0,1.79-4.47,1.42-5S322.37,92.85,322.37,93.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M328.46,106.7c-2.67.53-11.33.4-13.77.36.21,3.94.09,7,.09,7s13.77-.55,16.52-3.13c.64-.6,1-2.88,1.21-5.61A21.8,21.8,0,0,1,328.46,106.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M332.52,93.65c-.3-2.19-25.07-1.34-25.77-.92l.56,2.08a138,138,0,0,1,20.89-1.12C330,93.85,332.6,94.17,332.52,93.65Z"
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-73",
    width: 36,
    height: 22,
    transform: "translate(287.29 54.57)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAWCAYAAACosj4+AAAACXBIWXMAAAsSAAALEgHS3X78AAAB5klEQVRIS8XUvWsTcRjA8e+ZkktydStZLBWsWtDFKiKU0j+gq4NgOhTUUEQQfElEQ5I7U4ujrVAoBkIrLkVwsVK0pbuDloqYWAhWcQiBUPHiS4bHQX7nC9U0aS73hRvu4YbPPcf9tKWFeSkUy5TKJZLJpIbHaSJC38E+iYxECHeFGTs/5imqAyBfyGvBQECOHztCqVwSwLNtaSLi3Mxlp6Rzdw9rb1adWbthf4BUmXRcDh8a8AS2JQjAsixZe/mc4eGTvP+44czdhv0TpLIsS54tLnA6MopdtTFChqt/ZF2QamZ6UoJ+jc9fO6h+sbGrVVdQ2wapctlpuXDxKrFYzJm1EtYwSPX40QO5czfH4NCgM2sFrGmQaunJvCyvrKIbfme2E9iOQaq57JQEQ3t4/faVM2sG1jKQKpOOS+/+o2x+qlCr1ahsVhqC7ar3QKMl0re19WKe2dl7AAQDASzL2vZbt3xDv3c/NyPXEjeJRs85s3rbchWkWll8KE+XX6AbfsJd4f8erG0BqTLpuOzr7We9WAC23lZbQQATt8bl+o0EpmkC0BkyuHTl8i+YiHhyjY6cEl3XxTRNMU1T1LztG/o7n88nqVQK+PkJPQcB7O3pljNno4AL51Azvdv4oJ3oP8A3+zs/AIbxQG/4SB/NAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M35.64.58A10.86,10.86,0,0,0,28.35,9.8C27.1,22.8,25.06,37.44,25,46.85c-.07,7.47.36,47.9.48,58.78A3.52,3.52,0,0,0,28.1,109l13.46,5.4h2.31Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "119.56 112.81 217.51 112.81 217.51 114.99 120.17 114.66 119.56 112.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "34.7 112.66 63.24 112.73 70.14 114.5 41.59 114.4 34.7 112.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M41.56,114.4l-15-4.25c-.73-.12-1.25-.56-1.27-1.06l-.13-12.4c0-.18.21-.32.47-.32L41.51,97Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-78",
    points: "25.43 96.4 25.42 95.22 41.48 95.22 41.51 97.01 25.43 96.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M26.79,96.4l-1.15,0c-.26,0-.48.14-.47.32l.13,12.4c0,.5.54.94,1.27,1.06l.22,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M320.15,74.12c-1.28-2.34-25.31-14.54-28.79-16.17-1.06-.5-66.31-2.51-66.42-1.5-.35,3.25,51.95,15.63,61.35,19.77,5.67,2.49,17.49,12,21.6,14.66,3.17,2.06,16.8,1.33,17.5-.39C326.9,86.81,320.79,75.3,320.15,74.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M319.68,74.1c-1.32-2.31-24-13.83-27.29-15.37-1-.47-60.62-2.27-60.7-1.32-.23,3.07,47.71,14.53,56.39,18.52,5.24,2.4,16.13,11.34,20.11,13.92,3,2,15.79,1.27,16.44-.31C326.07,86.05,320.32,75.2,319.68,74.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M319.22,74.07C317.86,71.8,296.54,61,293.41,59.52c-1-.46-54.93-2-55-1.15-.13,2.9,43.46,13.43,51.42,17.27,4.8,2.31,14.77,10.71,18.61,13.18,2.89,1.86,14.79,1.21,15.39-.24C325.23,85.3,319.84,75.11,319.22,74.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M318.76,74.05c-1.41-2.24-21.38-12.4-24.33-13.75-1-.44-49.23-1.79-49.23-1,0,2.73,39.22,12.33,46.46,16,4.37,2.22,13.41,10.07,17.12,12.44,2.74,1.76,13.78,1.14,14.33-.16C324.4,84.54,319.36,75,318.76,74.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M318.29,74c-1.45-2.21-20.06-11.7-22.84-13-.92-.42-43.53-1.55-43.5-.79.11,2.55,35,11.23,41.5,14.77,3.94,2.13,12.05,9.43,15.62,11.7,2.6,1.66,12.78,1.08,13.27-.08C323.57,83.78,318.88,74.92,318.29,74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M317.83,74c-1.51-2.18-18.76-11-21.36-12.15-.89-.39-37.83-1.3-37.76-.61.22,2.38,30.73,10.13,36.54,13.52,3.49,2,10.68,8.79,14.12,11,2.46,1.55,11.77,1,12.21,0C322.74,83,318.4,74.83,317.83,74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M317.37,74c-1.56-2.14-17.45-10.28-19.87-11.35-.86-.37-32.14-1.06-32-.43.35,2.21,26.49,9,31.58,12.27,3.06,2,9.31,8.16,12.63,10.22,2.31,1.45,10.76,1,11.15.07C321.9,82.27,317.92,74.74,317.37,74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M316.9,74c-1.61-2.11-16.14-9.57-18.38-10.54-.82-.36-26.43-.82-26.31-.26.48,2,22.25,7.94,26.62,11,2.62,1.86,7.95,7.52,11.13,9.48,2.17,1.35,9.76.9,10.09.15C321.07,81.52,317.43,74.65,316.9,74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M316.44,73.94c-1.68-2.06-14.83-8.85-16.9-9.73-.79-.34-20.73-.58-20.57-.08.6,1.87,18,6.84,21.65,9.77,2.19,1.77,6.59,6.88,9.64,8.74,2,1.25,8.75.84,9,.22C320.24,80.76,317,74.57,316.44,73.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M316,73.92c-1.75-2-13.53-8.14-15.42-8.93-.75-.31-15-.33-14.84.1.74,1.7,13.76,5.74,16.69,8.53,1.76,1.67,5.23,6.23,8.14,8,1.89,1.15,7.75.78,8,.3C319.42,80,316.46,74.48,316,73.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M315.51,73.9c-1.81-2-12.21-7.43-13.92-8.13-.73-.29-9.33-.09-9.11.28.88,1.52,9.51,4.64,11.72,7.28,1.32,1.58,3.87,5.6,6.65,7.25,1.75,1,6.75.72,6.91.38C318.59,79.26,316,74.39,315.51,73.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M311.14,79.55c1.61,1,5.75.66,5.86.45.79-1.49-1.52-5.69-1.95-6.12-1.9-1.9-10.91-6.72-12.44-7.33-.69-.27-3.62.15-3.38.46,1,1.33,5.27,3.54,6.76,6C306.88,74.54,308.49,78,311.14,79.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M283,55.5c-2-2-14-16.33-15.88-18.42-7.23-8.07-12.24-12.34-11.37-13.29.67-.72,11.31,9.18,13.32,11.41,2.35,2.63,13.3,14.37,16.19,17.12,5.17,4.9,8.31,8.7,7.85,9.25S285.62,58.17,283,55.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M285.25,52.43c4.71,4.47,7.56,8,7.14,8.45s-6.81-3.1-9.23-5.5c-1.91-1.9-13.1-15.24-15-17.38-6.8-7.59-11.48-11.62-10.67-12.5.62-.67,10.55,8.61,12.46,10.75C272.17,38.74,282.51,49.84,285.25,52.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M285.24,52.55c4.26,4,6.82,7.18,6.43,7.65s-6.12-2.8-8.34-4.94c-1.8-1.75-12.2-14.15-14.17-16.35-6.36-7.1-10.71-10.89-10-11.69.58-.63,9.78,8,11.61,10.07C272.92,39.65,282.66,50.11,285.24,52.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M285.24,52.66c3.8,3.61,6.08,6.43,5.72,6.86s-5.45-2.5-7.46-4.39c-1.68-1.58-11.29-13.05-13.31-15.3-5.93-6.62-9.95-10.17-9.26-10.9.53-.57,9,7.47,10.76,9.41C273.67,40.55,282.81,50.37,285.24,52.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M285.23,52.78c3.35,3.18,5.34,5.66,5,6s-4.77-2.19-6.56-3.82c-1.58-1.43-10.39-11.95-12.46-14.27-5.5-6.13-9.19-9.44-8.56-10.1s8.26,6.9,9.9,8.74C274.43,41.46,283,50.64,285.23,52.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M285.23,52.9c2.89,2.74,4.59,4.9,4.3,5.25s-4.1-1.89-5.68-3.26S274.37,44,272.24,41.66c-5.06-5.65-8.41-8.72-7.85-9.31s7.49,6.34,9.05,8.08C275.18,42.37,283.12,50.91,285.23,52.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M285.22,53c2.44,2.31,3.85,4.14,3.59,4.45s-3.42-1.57-4.79-2.7S275.44,45,273.27,42.57c-4.62-5.16-7.65-8-7.15-8.51s6.73,5.77,8.2,7.41C275.94,43.28,283.27,51.18,285.22,53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M285.21,53.13c2,1.87,3.12,3.38,2.88,3.65s-2.76-1.26-3.9-2.14S276.52,46,274.3,43.49c-4.19-4.68-6.89-7.27-6.45-7.72s6,5.21,7.34,6.75S283.42,51.44,285.21,53.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M285.21,53.25c1.53,1.44,2.37,2.61,2.17,2.85s-2.11-.94-3-1.58c-1.16-.81-6.76-7.58-9-10.11-3.75-4.2-6.12-6.54-5.74-6.93s5.2,4.64,6.49,6.08S283.57,51.71,285.21,53.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M285.2,53.36c1.08,1,1.63,1.86,1.46,2s-1.46-.61-2.13-1c-1.06-.66-5.85-6.48-8.18-9.08-3.32-3.7-5.36-5.81-5-6.13s4.44,4.08,5.64,5.42S283.73,52,285.2,53.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M285.2,53.48c.61.58.89,1.09.75,1.25s-.83-.26-1.24-.46c-1-.48-4.95-5.38-7.33-8-2.89-3.22-4.59-5.09-4.34-5.34s3.67,3.51,4.78,4.75S283.88,52.25,285.2,53.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M285.19,53.6c-1.17-1.08-5.48-5.78-6.49-6.91s-3.77-4.22-3.92-4.08,1.17,1.81,3.63,4.54,5.51,6.86,6.47,7a.4.4,0,0,0,.35-.11A.29.29,0,0,0,285.19,53.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M329.22,76.27c-10.07-8.29-33.87-21-33.87-21l-1.75-.11L288.48,55a12.64,12.64,0,0,0,2.78,2.37c1.35.73,26.56,14.13,28.76,16s4.42,4.12,4.42,4.12l6.17.53A6.14,6.14,0,0,0,329.22,76.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M331.82,87.74s-10,0-11.33-1.2-6.14-14.08-4.62-14.14,12.48,2.18,14.74,5.51C332.63,80.86,333.5,86.75,331.82,87.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M331.82,87.74s-10,0-11.33-1.2-6.14-14.08-4.62-14.14,12.48,2.18,14.74,5.51C332.63,80.86,333.5,86.75,331.82,87.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M331.82,87.74s-10,0-11.33-1.2-6.14-14.08-4.62-14.14,12.48,2.18,14.74,5.51C332.63,80.86,333.5,86.75,331.82,87.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M315.87,72.4a10.6,10.6,0,0,1,1.74.2c.33,3.15,3.74,12.28,4.86,13.24s7,1.12,9.83,1.18a1.1,1.1,0,0,1-.48.72s-10,0-11.33-1.2S314.35,72.46,315.87,72.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M327,82.45c-2.21-3.25-9.27-7.49-11.1-7.61-.33-1.43-.4-2.43,0-2.44,1.51-.07,12.48,2.18,14.74,5.51,2,2.88,2.73,8.6,1.31,9.72C329.5,87.59,328.14,84.2,327,82.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M325.35,82.79c-.09,1.5.26,2.74.78,2.77s1-1.16,1.09-2.66-.26-2.74-.78-2.77S325.44,81.29,325.35,82.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M326.44,80.13c-.52,0-1,1.16-1.09,2.66s.26,2.74.78,2.77l-7.24-1.93-1.7-4.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M327.88,83.24c-.09,1.5.26,2.74.78,2.76s1-1.16,1.09-2.66-.26-2.73-.78-2.76S328,81.74,327.88,83.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M315.79,72.8c.1.65,10.52,4.11,12.6,5.61s3.6,8.66,3.75,8.35-1-7.27-2.9-8.77S315.72,72.26,315.79,72.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M256.61,21.73c.84,2.08-36-4.69-54-6.15C188.7,14.44,62.3,8,61.6,5S188.28-.2,210.38,1.19C237.18,2.88,252.44,11.43,256.61,21.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M255.36,21.16c.75,2-36-4.61-52.56-6C189.63,14,72.81,7.76,72.21,4.83S190,.1,210.93,1.49C236.71,3.22,251.68,11.56,255.36,21.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M254.11,20.59c.67,1.86-36-4.48-51.15-5.83-12.41-1.11-119.63-7.25-120.13-10S191.71.4,211.49,1.78C236.24,3.57,250.92,11.7,254.11,20.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M252.86,20c.58,1.75-36-4.37-49.74-5.67C191.48,13.25,93.84,7.26,93.45,4.6S193.43.7,212,2.08C235.77,3.92,250.15,11.83,252.86,20Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M251.61,19.45c.49,1.65-35.94-4.28-48.33-5.51C192.4,12.85,104.36,7,104.07,4.49S195.15,1,212.59,2.38C235.3,4.22,249.38,12,251.61,19.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M250.36,18.88c.41,1.54-35.92-4.18-46.92-5.36-10.11-1.07-88.57-6.77-88.75-9.15s82.18-3.11,98.45-1.7C234.83,4.56,248.6,12.13,250.36,18.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M249.11,18.31c.32,1.44-35.91-4.09-45.52-5.2-9.33-1.07-78.2-6.61-78.28-8.86S198.59,1.56,213.69,3C234.37,4.9,247.81,12.28,249.11,18.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M247.87,17.74c.21,1.34-35.91-4-44.12-5-8.57-1.07-67.85-6.45-67.83-8.56s64.38-2.28,78.33-.87C233.9,5.25,247,12.44,247.87,17.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M246.62,17.17c.12,1.24-35.89-3.94-42.71-4.88C196.11,11.22,146.41,6,146.54,4S202,2.17,214.8,3.56C233.43,5.6,246.17,12.61,246.62,17.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M245.37,16.6c0,1.14-35.88-3.88-41.3-4.72-7-1.09-47.14-6.13-46.91-8s46.58-1.43,58.19-.05C233,6,245.31,12.79,245.37,16.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M244.12,16c-.1,1-35.86-3.84-39.89-4.56-6.26-1.13-36.79-6-36.45-7.68s37.67-1,48.12.37C232.48,6.35,244.42,13,244.12,16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M242.87,15.46c-.24.93-35.84-3.81-38.48-4.4-5.48-1.23-26.43-5.81-26-7.38s28.77-.57,38,.77C232,6.7,243.48,13.1,242.87,15.46Z"
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-120",
    width: 9,
    height: 24,
    transform: "translate(24.29 66.57)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAYCAYAAAAoG9cuAAAACXBIWXMAAAsSAAALEgHS3X78AAABE0lEQVQoU73SsW7CMBSF4d+xo7KRicBGhyhLkcJEnykPwZBHoS9TZlhYqAoDUoZQxECURL0dDDSlJOrUu3j5dHx1bCUiAMLNlGWJ67oKwMznrz/AYDBgt9uxWq0Iw1Amk2dlfN9nNnu5DaLTeSAMQwAxw+Ejo9ETi8WS6XSqLihJkusNzq+I2jiOtqeIcDwe7yJjzqgoirsAQOszyvP8L+iE53nt6HRqSzIW5XlOWZYNqLZT0/JXFEUR2+22HQH0+/1GlKZpe+ObzTtaa4t6Pb8RGqPbk8DW4ABU1f0KLNIXVP0TMnVU/43jcUS3ax/eAARBwHr9RhzHZFnGfp8BcDh8ACglIoiIiHyi1HcjSikABfAFdOBtH2RssRgAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 24.26,
    y: 68.42,
    width: 7.22,
    height: 20.28,
    rx: 0.95,
    transform: "translate(55.74 157.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 24.26,
    y: 68.42,
    width: 7.22,
    height: 20.28,
    rx: 0.95,
    transform: "translate(55.74 157.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-122",
    points: "30.66 74.73 26.05 74.73 26.05 69.71 30.71 69.71 30.66 74.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M24.79,72.22c0,1.39.56,2.51,1.26,2.51s1.26-1.12,1.26-2.51-.56-2.51-1.26-2.51S24.79,70.84,24.79,72.22Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "30.66 81.14 26.05 81.14 26.05 76.12 30.71 76.12 30.66 81.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M24.79,78.63c0,1.38.56,2.51,1.26,2.51s1.26-1.13,1.26-2.51-.56-2.51-1.26-2.51S24.79,77.24,24.79,78.63Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-125",
    points: "30.66 87.54 26.05 87.54 26.05 82.52 30.71 82.52 30.66 87.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M24.79,85c0,1.38.56,2.51,1.26,2.51s1.26-1.13,1.26-2.51-.56-2.51-1.26-2.51S24.79,83.64,24.79,85Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-126",
    x: 24.57,
    y: 69.22,
    width: 3.37,
    height: 18.99,
    rx: 1.18,
    transform: "translate(52.52 157.42) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M25.27,88.2h0a.66.66,0,0,1-.7-.61V69.83a.66.66,0,0,1,.7-.61h0a.66.66,0,0,1,.7.61V87.59A.66.66,0,0,1,25.27,88.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M30.8,68.41H28.73a1,1,0,0,1,1,.89V87.81a1,1,0,0,1-1,.88H30.8c.38,0,.68-.59.68-1.32V69.74C31.48,69,31.18,68.41,30.8,68.41Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-129",
    points: "116.67 104.08 267.15 104.08 267.15 98.81 114.91 98.81 116.67 104.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "73.65 104.08 41.56 104.08 41.56 98.81 75.41 98.81 73.65 104.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M314.94,110.6a26.42,26.42,0,1,0-52.84.33v5.86a.79.79,0,0,0,.79.79h3.32a.8.8,0,0,0,.79-.79v-5.88a21.52,21.52,0,1,1,43-.32v4.67h1.33l3.57-.76Z"
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-73",
    width: 54,
    height: 90,
    transform: "translate(220.29 21.57)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAABaCAYAAADzc6X8AAAACXBIWXMAAAsSAAALEgHS3X78AAAFXUlEQVR4Xt2cXWwUVRiGn29dhVAQw39ooTFEIIZ4q95gQIN4IQIWBBRSUW5ARRDjBXGQsrT81cqWtSggYkGKICYSbTBqlB8RxSBYm9Tyo1KCLIWEtrC7yu7xYna2s2Hb2W4L3TlPMmlm59vd8+73nm/OOTNTUUrhf6dULVy0hNmz5nAjeoNUhEIhVEwRUzGUUiilCIVCxGKx5E3FuHLlciIm1TZu7EPMmD6Fo8frMAxDUn5hJxGlFJOfnKjGjZ/IL8eO07dv3+SGALS7r0CRtK+U7bUU+6PvH5VowJhRD/Bs4UwC/nXMnbegy0TK3l3bVG393/Tu1ZuFi17tsg9Oh6KiIgUwaMAgAI4e+Y6tlVVd0gb55svd6tDPtbfMEuliiTz4/SFmzniq09nzQOsv1p1YP+zjEycQjggfbAoop/e0hwdAdeojug7DMGTJ60sEoOHCZSq3lGfcMo/5J+P33xLmvzRfAK5F7mT/vp0ZNc7jFNCdXA9d5+y5qxz46rMOi8sqK9oxDENarrUQCoeoPXWRb6v3dKiVWWlFC8MwpLmlmXAkzB9nG9m/b1faDc1qK4Iprqm5iWBjkPP/XOfzPZVpiYtbMa3YbsM6FTRcOMe18F1Ubd/s2OCsz5iFJa7+TB2KPnz80aZ2xXno1Pn99mIX16NHf3Zse79Nca6woh1L3O91NeTkDGlzhOIaK9qxxJ2s/ZV77s5NKc6VwqBVXE3dSaI3elJc7EsSZ1oxS89jTljiLlw6T7jlP3y+FQkhHoFsPT+nhSXO2/MOwi3/JqY/rrWiHUtc3vBcli1bBrjcinYMw5BgY5CKQAWB8jJlZsz9uoBWcWNG5eMB0SJjdsKRiB59zI7ER1JaWRFA4mNEbYpHgqSMaYSILWM6JQxdrSjaWtGeMa1I9DFx10TTCWtBQLuMiQhXrzZl97piZsStKGTnSnCmiJhZ086KZvEQ/awomNqy9qJEpogIgo5WREDQ0Ir24qGTFZMGwTohIvZyr0/KJL7pZ0Wzk5mrVHplLMmKGiF2KzrEuglptSJadTKJz6Fddak2LeKDRf2siJiDYAG9rKjvIBhNrShW8QCtrIh1go5GY06RriK+MqDjEre9eOijy0Q0HVLZyr0e0lasMO/x+OlEPV6nYDchIpz7q4GVq32izUTT5zPvpRo9cjCg0SqVCISaI8x+4WUBTRZziotXJmULMPuY26+PCcKI/JE889y0xCTM9RkrKSlRAPWnjiW97gUY2L/7H9rJFBEYfd8YJhdMSpoyuzpjq1etUgA1NYdvOubqPiYi3DtsBNNnTUvKFrjwLm6LNavXKIDq6k9THvci7hQmIuQNzScciaQ87korrlu7VgFs37GJL6q/TrnO5hXcJwyEAf368+DDY9uM8IIQU+6ZRZeuK1UAW7e+x4HDP7a5Kuo6K4oIOb1yeLqgoN04Vwmz7qnf9uFmTvxW2+4atquqYp/efUApCgsLnULdVTxEhOKSlQQvNTpecXDNCXp92XoFsKp4uVMo4KI+JiIsfm0x0WjUMVvgkoz51/vNorGlwik0gRey/0kJQVj65lKampvSyha44A7TDf4NCiDgX+sUmkS8KmbvyENEeLusjDNnT6edLcC8KJGtGQuUm89e+kuLnEJvIqurooiws6qKg4cOdChbkMVVsSJQoQCWL33FKTQlHoAB/QY6xXUDwg+HjzD+iYIOZwvA82fDRYKNQcr9mf+3k65m47sbFcC856c4hbaJd+68BTJt6nT16GPjyR+e1+3icocOYc6cF8kdnMMjE6ZmlC2IF4/dez8R31tvqPxheU7xt4XT9ScJNg5hklNgO/wPxvVRbtgZcnEAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M228.48,25.13l19.06.08a11.87,11.87,0,0,1,8.39,3.52l21.22,21.43a3.69,3.69,0,0,1-2.78,6.29l-46-1.89a3,3,0,0,1-2.84-3V28.1A3,3,0,0,1,228.48,25.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M274.43,55.05l-46-1.88a1.57,1.57,0,0,1-1.5-1.57V28.1a1.57,1.57,0,0,1,1.57-1.57l19.07.08a10.37,10.37,0,0,1,7.39,3.1l21.22,21.43a2.29,2.29,0,0,1-1.61,3.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M276.15,51.14,254.93,29.71a10.37,10.37,0,0,0-7.39-3.1l-19.07-.08a1.57,1.57,0,0,0-1.57,1.57V30l19.94.51a9.44,9.44,0,0,1,2.85.51V54l1.34.05V31.58a9.4,9.4,0,0,1,2.2,1.57l12.71,12.12c-.05,1.23-.16,3.24-.32,2.5-.21-1.05-1-3.32-3.54-2.89s-4.19,9.5-4.19,9.5l1.09,0,.7-2.72s1.75.22,1.92.22a13.74,13.74,0,0,1-.7,2.58l8.36.34,1.1-5.36,5.44,5.19a2.39,2.39,0,0,0,.84-1A2.22,2.22,0,0,0,276.15,51.14Zm-15-1.06h-1.05a11.12,11.12,0,0,1,1.18-2.88c.53-.53.53.39.53.61S261.12,50.08,261.12,50.08Z"
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-73",
    width: 58,
    height: 36,
    transform: "translate(223.29 22.57)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAAkCAYAAADYZynDAAAACXBIWXMAAAsSAAALEgHS3X78AAADsElEQVRoQ92Zv08bVxzAP9/nOxtzNpbAgEgR1HGaIoJBHpzBYkhT0hRIt7ihgdBUYg9KlY4MtzaNmq2RmJut+Q8KA7AgIUSjZmFJWRAScuyCCFzgdbDOPZIqEMCu7Y9k3fO784/P+379fT59RWuNi23bGiASaeA0iEhxrLUml8sDMDU19e+JMiNaa2zb1koJSiksy8I0TQ4ODv7zBd6FOc45rTX7+/uHHpZlkc//XVZx0Vrz+PHP+uDggJ6eHl6+/IuJiYkz/QI7Ozt6fX2d58//YG1tDcdx2N3d5fXr3bLJyqNHP+m9vT2GhoZJJBJl+dCNjQ399OmvOI7D3t4eb97sl1xYKaUIh8NlkwRoaWmRe/cmJRqNAtDQEC7Wh1KhHMchlUoddV1JuHv3OxkcHEJEiEQaSiqrdnZ2jrqmpCSTSblzZxwobWTVUReUg8bGRhkbGwMgHA6VRFZ597z/k6amqIyOlk62YkQBmpub5fbtUQBCIetMZSsidb20trbKyMg3AFhW/ZnJVlREXdra2mRkZAQ4O9mKFAU4d+4juXWrIFtfHzy1bMWlrpf29nbJZL4GIBisO5VsxUbUpaOjQzKZDACmaZxYtuJFATo7P5abNzPU19efuBpXdOp6icVicuPGV/h8vhMVqKqIqEs8Hpfh4WEMw/hg2aqJqMuFC5/I4ODgB8tWVURdLl78VK5f/xLDMI699VSlKEBXV5dcu/YFpmkeS7bqUtdLd3e3DAwMYJrmkfts1UbU5dKlHrl69XP8fv97ZateFCCRSMiVK5+9V7aqU9dLX1+fpNNp/H4/dXWBd2RrIqIuqdRlSafTBAKBd2SNWhKFgiygFxcXCQQCxfmaSV0vqdRlSSaT5HL5YlRrKnW9PHjwA9FoU7GPpNwGUK0xNzcnvb29xQaXAlhYWGBra+vIv1HVxvnzcaDQJVQAuVyeFy/+ZHp6uqZk29ragEK7UrnNnZmZGba3t8hmszqbzWrHcTSgV1dX9fT0tJ6cnNT9/f1aRKpiMbLZrH748Mfib1TcnqZt29qdHB//lidPfkEphYggIofG7nOfz1d847q6IMFgHaFQCBGhqSmKUgqlhI6OTpQSRFTxGApZgLC9vc3y8jKzs7MsLS0xPz/P5ubmqSrkzMzvemVl5VADWt5u3tq2rb2F2FuVSzk2DOPQvGmaeCncf1rEYrHiYkPhGI/HUUrx7NlvvHr1CsMwyOXyhEIW9+9/L+CJaDk46lbqNEQiDby9g3h7rv8AEUNSs6rZfw4AAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-73",
    width: 55,
    height: 33,
    transform: "translate(224.29 24.57)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADcAAAAhCAYAAAB9VDPAAAAACXBIWXMAAAsSAAALEgHS3X78AAADeElEQVRYR9WZ30tbVxzAP99zY/jWOtuupgTdalixEVlZsUZffJY6sw6p61o6pKM/6Og6nIW8GfD+LXlZfZ7FPsUHH/K6zo50qBFWXzIEa9C8yNlDTBq1M1YTzf3A4Ry+9xxyP3y/595wrlhrcV3XUsbExAQA1tod/cFjFmthdnaWVCpFOfF4XDgmxFrLzMyMBQiHwwSDQRKJBMaYPa21tbU0dhyHQCCAMYampib8fj/GGJqbm0uSm5ubLCwssLKywtu3/9DW9hnr6+94/fqvY5GUyclJCxCLxVDVmv7gxsaGnZ7+nWw2Szb7b80FDcClS1/UXAygsbFRRka+k2vXegB4/vw3u3tLVBNjjNDSEqg0r6r09vZKLBbjzJmzRCI9e/Z8tTDGmEpzaoKqysDAAADd3d01ETwxOQARkevXBwG4evWrqgsax3EqzakpIiJDQ0MAXLnyZVUFTzRzRUREotFvAOjq6qqaYF3IQeHJNjj4NQCdneGqCJ54WZajqhKNRgHo6Og4smDdZK6IqsqNG98ChffvUQTrTg4KgsPDwwCEQu2HFqyrsixHVeXmzREALl78/FCCdZm5Iqoqt259D0BbW+tHC9a1HBQEb9++A0AwGPwowboty3JUVe7e/QGACxcCBxas+8wVUVUZHR0F4Pz5Tw8k6Bk5KAjeu/cjAOfOna0o6ImyLEdV5f79BwA0N3+yr6CnMldEVeXhw0cAnD7d+L+CnpSDguDjxz8BcOqUflDQGOOwubmxZ7EXUFV58uRnAPz+hj2CZn5+/oMLvYKqytOnvwDg8zk7BA2AMd56qOxGVWVs7FcAjJGS4LacN/ddOaoq4+PPiER6SzEfgON4Xw4KguFw2AK4rmtLZSkiFd/4XiAUCknxxNsApFIpFhcX913kJUSEy5c7MOVH2i9eTNtMJmNfvfrDptNpm8lk7Orqql1bW7O5XM7m83lbJJlM2rGxMdvf319XGc/n83Z9/R1v3vxNKYWu69pIpIeWlgAvX87gOE7pg0f52BgHxzH7xArj3bH29nZEBGMEEbM9LvSBQAARKbWGhgaWlpZIJpNMTU0xNzdHLpereNy/tbVll5eXSSQSxONxKckdBtd1rTHvb7LQG44a23ntfczn822Pi624VgiHO0mn0wDMz//J+Pizo8kdB5X++Rfp6+sjlUrt+HL0H3CSNgHjfrcsAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-132",
    points: "254.35 54.8 253.01 54.8 253.01 27.68 254.35 28.38 254.35 54.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-135",
    points: "253.31 54.25 253.01 54.25 253.01 28.17 253.31 28.37 253.31 54.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-136",
    points: "254.04 54.25 254.35 54.25 254.35 29.16 254.04 28.91 254.04 54.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M269.43,42.78l-.17,13.58a.62.62,0,0,0,.6.64l11.47.61a1.77,1.77,0,0,0,1.35-3L270.52,42.34A.64.64,0,0,0,269.43,42.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M267,41.11H275a.74.74,0,0,1,.74.74v9.62a.74.74,0,0,1-.74.74h-5.38a6.57,6.57,0,0,1-6.57-6.57V45A3.87,3.87,0,0,1,267,41.11Z",
    transform: "translate(538.89 93.32) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M263.86,52.1h8a3.76,3.76,0,0,0,3.76-3.76v-.65a6.47,6.47,0,0,0-6.47-6.47h-5.26a.73.73,0,0,0-.73.73v9.42A.73.73,0,0,0,263.86,52.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M263.86,52h7.88a3.64,3.64,0,0,0,3.64-3.64V47.7A6.36,6.36,0,0,0,269,41.34h-5.16a.71.71,0,0,0-.71.71v9.22A.71.71,0,0,0,263.86,52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M263.87,51.87h7.77a3.54,3.54,0,0,0,3.53-3.54v-.62a6.25,6.25,0,0,0-6.25-6.25h-5.05a.69.69,0,0,0-.69.69v9A.7.7,0,0,0,263.87,51.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M263.88,51.75h7.67A3.42,3.42,0,0,0,275,48.33v-.61a6.15,6.15,0,0,0-6.15-6.15h-4.94a.69.69,0,0,0-.68.68v8.82A.69.69,0,0,0,263.88,51.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M263.89,51.63h7.56a3.31,3.31,0,0,0,3.31-3.31v-.59a6,6,0,0,0-6-6h-4.83a.67.67,0,0,0-.67.67V51A.67.67,0,0,0,263.89,51.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M263.9,51.52h7.46a3.19,3.19,0,0,0,3.19-3.2v-.58a5.93,5.93,0,0,0-5.93-5.94H263.9a.66.66,0,0,0-.65.66v8.4A.66.66,0,0,0,263.9,51.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M263.91,51.4h7.35a3.08,3.08,0,0,0,3.09-3.08v-.57a5.83,5.83,0,0,0-5.83-5.83h-4.61a.64.64,0,0,0-.64.64v8.2A.64.64,0,0,0,263.91,51.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M263.92,51.28h7.25a3,3,0,0,0,3-3v-.55A5.72,5.72,0,0,0,268.42,42h-4.5a.62.62,0,0,0-.62.62v8A.62.62,0,0,0,263.92,51.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M263.93,51.17h7.14a2.86,2.86,0,0,0,2.86-2.86v-.54a5.62,5.62,0,0,0-5.61-5.62h-4.39a.61.61,0,0,0-.61.61v7.8A.61.61,0,0,0,263.93,51.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M263.94,51.05h7a2.75,2.75,0,0,0,2.75-2.75v-.52a5.51,5.51,0,0,0-5.51-5.51h-4.28a.58.58,0,0,0-.59.59v7.6A.58.58,0,0,0,263.94,51.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M264,50.93h6.94a2.63,2.63,0,0,0,2.63-2.63v-.51a5.4,5.4,0,0,0-5.4-5.4H264a.57.57,0,0,0-.58.57v7.4A.57.57,0,0,0,264,50.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M264,50.82h6.83a2.52,2.52,0,0,0,2.52-2.52v-.51A5.29,5.29,0,0,0,268,42.5H264a.56.56,0,0,0-.56.56v7.2A.56.56,0,0,0,264,50.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M264,50.7h6.74a2.41,2.41,0,0,0,2.41-2.41V47.8a5.18,5.18,0,0,0-5.19-5.18h-4a.54.54,0,0,0-.54.54v7A.54.54,0,0,0,264,50.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M264,50.59h6.63a2.3,2.3,0,0,0,2.3-2.3v-.48a5.07,5.07,0,0,0-5.08-5.07H264a.52.52,0,0,0-.52.52v6.8A.52.52,0,0,0,264,50.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M264,50.47h6.53a2.18,2.18,0,0,0,2.18-2.19v-.46a5,5,0,0,0-5-5H264a.51.51,0,0,0-.51.51V50A.51.51,0,0,0,264,50.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M265.57,43H272a.49.49,0,0,1,.49.49v6.39a.49.49,0,0,1-.49.49h-3.63a4.87,4.87,0,0,1-4.87-4.87V45A2.07,2.07,0,0,1,265.57,43Z",
    transform: "translate(535.99 93.32) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M268.6,46.89c3.31,2.24,6,2.83,6.58,2s.54-3-2.34-6.26c-1.53-1.73-8.38-1.75-8.94-1S266,45.1,268.6,46.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M268.64,46.65c3.12,2.1,5.68,2.63,6.2,1.88s.5-2.85-2.22-5.91c-1.45-1.63-7.89-1.62-8.41-.87S266.14,45,268.64,46.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M268.68,46.4c2.94,2,5.34,2.44,5.83,1.71s.45-2.71-2.11-5.55c-1.37-1.52-7.4-1.5-7.89-.77S266.33,44.83,268.68,46.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M268.73,46.16c2.74,1.82,5,2.24,5.45,1.54s.41-2.57-2-5.2c-1.3-1.42-6.91-1.37-7.37-.67S266.52,44.7,268.73,46.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M268.77,45.91c2.56,1.68,4.65,2.05,5.07,1.38s.37-2.42-1.89-4.85c-1.21-1.31-6.42-1.25-6.83-.57S266.71,44.57,268.77,45.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M268.81,45.67c2.38,1.53,4.31,1.85,4.7,1.21s.32-2.28-1.78-4.5c-1.13-1.21-5.93-1.12-6.31-.47S266.9,44.43,268.81,45.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M268.86,45.42c2.18,1.4,4,1.66,4.31,1s.28-2.13-1.66-4.14c-1.06-1.1-5.44-1-5.79-.38S267.09,44.29,268.86,45.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M268.9,45.18c2,1.25,3.63,1.46,3.94.87s.23-2-1.55-3.8c-1-1-5-.86-5.27-.27S267.28,44.16,268.9,45.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "M268.94,44.93c1.81,1.11,3.29,1.27,3.57.71s.18-1.85-1.44-3.45c-.9-.88-4.46-.73-4.74-.17S267.48,44,268.94,44.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M269,44.68c1.62,1,2.94,1.08,3.18.55s.14-1.71-1.33-3.1c-.81-.78-4-.6-4.21-.07S267.67,43.89,269,44.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "M269,44.44c1.44.83,2.6.88,2.81.37s.09-1.55-1.22-2.74c-.74-.67-3.48-.48-3.69,0S267.86,43.76,269,44.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M269.07,44.19c1.25.69,2.26.69,2.43.21s.05-1.41-1.1-2.39c-.66-.57-3-.35-3.16.13S268.05,43.63,269.07,44.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M269.12,44c1.06.55,1.91.49,2.05,0s0-1.27-1-2c-.59-.46-2.5-.22-2.64.23S268.24,43.49,269.12,44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M269.16,43.7c.87.41,1.57.3,1.68-.12a1.71,1.71,0,0,0-.88-1.69c-.51-.35-2-.1-2.12.33S268.43,43.36,269.16,43.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M269.21,43.46c.68.27,1.22.11,1.29-.3a1.32,1.32,0,0,0-.76-1.33c-.44-.25-1.53,0-1.6.43S268.62,43.23,269.21,43.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M269.25,43.21c.49.14.88-.08.92-.46a1,1,0,0,0-.66-1c-.36-.13-1,.15-1.06.53S268.8,43.09,269.25,43.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "M268.75,42.34a.59.59,0,0,0,.54.63.64.64,0,0,0,0-1.26A.59.59,0,0,0,268.75,42.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M305.67,73.8c0,12.21-109.55,18.33-176.21,18.33S42.78,88.69,41.56,73.8C40.84,65,54.24,49.88,120.9,49.88S305.67,58.42,305.67,73.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M301.12,73.83c0,11.23-101.49,16.91-164.43,16.91s-83-3.23-84.16-16.91c-.66-8.1,13.43-22,76.37-22S301.12,59.73,301.12,73.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "M296.57,73.87c0,10.25-93.43,15.47-152.65,15.47s-79.42-3-80.42-15.47c-.59-7.44,14.18-20,73.41-20S296.57,61,296.57,73.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M292,73.91c0,9.26-85.37,14-140.88,14s-75.78-2.81-76.67-14C74,67.14,89.4,55.82,144.91,55.82S292,62.34,292,73.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M287.47,74c0,8.28-77.31,12.6-129.1,12.6S86.22,83.94,85.44,74C85,67.85,101.12,57.8,152.91,57.8S287.47,63.65,287.47,74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M282.93,74c0,7.31-69.26,11.17-117.34,11.17S97.08,82.75,96.42,74c-.4-5.42,16.42-14.2,64.5-14.2S282.93,65,282.93,74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "M278.38,74c0,6.32-61.2,9.73-105.56,9.73S107.93,81.57,107.39,74c-.34-4.76,17.17-12.26,61.53-12.26S278.38,66.26,278.38,74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "M273.83,74.06c0,5.34-53.14,8.3-93.79,8.3s-61.26-2-61.68-8.3c-.27-4.09,17.92-10.32,58.57-10.32S273.83,67.57,273.83,74.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M269.28,74.1c0,4.36-45.08,6.86-82,6.86s-57.62-1.77-57.94-6.86c-.21-3.42,18.67-8.38,55.6-8.38S269.28,68.88,269.28,74.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M264.73,74.14c0,3.37-37,5.42-70.24,5.42s-54-1.56-54.19-5.42c-.14-2.75,19.42-6.44,52.63-6.44S264.73,70.19,264.73,74.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "M260.19,74.17c0,2.4-29,4-58.47,4s-50.35-1.36-50.44-4c-.08-2.08,20.15-4.5,49.66-4.5S260.19,71.49,260.19,74.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "M255.64,74.21c0,1.41-20.91,2.56-46.7,2.56s-46.69-1.15-46.69-2.56,20.9-2.56,46.69-2.56S255.64,72.8,255.64,74.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-179",
    d: "M229.59,67.37a3,3,0,1,0,2.95-3A2.95,2.95,0,0,0,229.59,67.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M226.49,68.39h11.32a1,1,0,0,0,1-1h0a1,1,0,0,0-1-1H226.49a1,1,0,0,0-1,1h0A1,1,0,0,0,226.49,68.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M196.1,67.37a3,3,0,1,0,3-3A2.95,2.95,0,0,0,196.1,67.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M193,68.39h11.32a1,1,0,0,0,1-1h0a1,1,0,0,0-1-1H193a1,1,0,0,0-1,1h0A1,1,0,0,0,193,68.39Z"
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-73",
    width: 74,
    height: 37,
    transform: "translate(134.29 22.57)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEoAAAAlCAYAAADlcn/+AAAACXBIWXMAAAsSAAALEgHS3X78AAACe0lEQVRoQ+2asU7bUBSG/3vji60gxQpRlmyR8gJUouIpmEnFGjYCnakiJSp7eYQyFKmA8gqeIjXeygMUFoRQhOUkrrlC4XQIDnYCtqW2A/h+k6987OHTOcdH8mFEhHkODj5TPp8H53zh3luDMQYigpQSmqZhPPbQarXYQlxYVKfTmR1MswAhxHz8m+X+/h4AIKXE3Z1ckDUTdXj4hSaTCSaTCcrlMra2tqBpYsHsW4UxRtfX1zg5+Y7bWwemWYDrDmfCNGCaSaXSCoQQqNc/oFgsZkZQABExANjZaVK//wO9Xi9ynwPA8nIeo9Eos5LCEBFbW3vPVlffAXhqR7zT6ZDn/UalUsm8pDCDwQCmWQB7NMLa7TaZZgHN5i4YY0pUCMdx6OjoK1x3CG4YOnK5nJL0DGdnZ7NrLqXMxLz0tyhDMYQTiKuKe5lgageUqFg450+iEmIzjSq9lEQySol6GdWjUqJ6VEpUj0pJUHqGoStRcXDOsbS0NL1OiM00QekRkcqoOJSolARulKgEIl+9mLjMo0ovJar0UqJKLyWq9FJyeXkJQIlKpFarAQCIAO66w9l/d0WU9fV1PDw8AAj1KMdxFtdaMs75+U9IKQE8inLdIY6Pv8U+lDUsyyLbtmEYBlqtFuPBtobv+7i5uVFZ9cjFxS94njc7R8aD09MT2HafGGOZFmbbfbq6ugIA7O19ZEBoPyq8RFYqrWBzs45ut4tGo/Hcu/4p1Wo1KeS/srGxge3tBizLgu/74JyDcx7Zj4ps3AFTYYahQ9f1Z1/62gi+WnHMrxSEBQUsiAKmsoTQIISA7/tPwXMz12s5j0ZjJJHLcezvf3pxqPwDNhoENB3JjwgAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-73",
    width: 64,
    height: 27,
    transform: "translate(139.29 27.57)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAAAbCAYAAADMIInqAAAACXBIWXMAAAsSAAALEgHS3X78AAAB1UlEQVRYR+2ZP4oiQRjF39clomhiIIIaKHiADjTRTPoGnsBLCDuBYCeGO7CTCYIXGFNH2Im6Md85g9KYzQY2SFe/CdTVWRg6ni5/UNDUv+Dx6iv6lZDEhUKhwMPhgDAMkSZIQkTgOA48z5Pbsczlo9vtEgBmsxmCIPh/j1Tg+z5EhABAUoCzALVajc1mE6+vv/Hyskaj0fikUlp4fPzJ9/e/WK/XEBGSFHQ6HVarVb69/SFJmNCOxyMBkCSsbDaLxWKB5+dlkoCpYTqdotfrQUSYAYBWqwXHcVJp+69ot9sAAGuz2YC83gQmMB6PJY5jxHEMSykFrXXSmtShtUYURbAymQziOE6anzq01tBaXwQwzwFRFF0doLV5DigWiycBlFJGOgCA2Q4AYHYNAO4OuNcA4x1wUwPMFOB+BEw/Ajf/AmY6QGsNAcAwDJHL5YzJA1zX5Xw+R71ehwUA+XweT0+/jAkF+v0+SqUSPM8Ti+d01LbtpHWpwHVdRlGE7XZ76jinQQTAIAg4mUyYFCp+17Zarai1pm3bLJfLJHmKxUmKiHAwGMD3fQDgaDT6QsPviVIKy+USw+EQlUoF+/3++i4AXB8KRIQPDz+g1L+hVLHb7T4V+w91+UkoHfwprwAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-73",
    width: 74,
    height: 37,
    transform: "translate(49.29 22.57)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEoAAAAlCAYAAADlcn/+AAAACXBIWXMAAAsSAAALEgHS3X78AAACaUlEQVRoQ+2av26bUBTGv4sNwXYT66qZPHjy7imu5DlN00dwHyHd0h1VzM0DNFO8NGszNYufo3kBL7FkBMY1gWtOh9YE/AdIFdV1uT/JA/ceuOLTd7gHfBgRYRnTNAkA6vWDlbk/oVwurx1ft3YafyM+DENMJi4Mw2DxORa/2MXFJxJCQNd1EBE0TXvyYptgLLHuP0sQBLGfiASLhIq7qNvtotN5BSLajbt7RizLouvrL7BtG9VqFbbtwDAMVgYeRTo8fImTkzdotVrsuZy0a3DO2dnZe1iWRf3+VTReBoD9/RcIggC93jtwzgvnonVwzlmlUiHHmcA0TSopikKVio5Go4Gjo44UKUa73f54d/cdqqpCAQDP83B6+jbrvMKhqirjnAMAFMYAXdexGJCsR8kKKDqLPU3ZlfpmexCISDoqi0WZJB2VAyKSQmVBtJR6Qoi0+MIjHZVB5CjGGGaz2c683W8DIoLi+0FWXKGJdj1gd74VbYvoYS6F2szKridJJ3KUdNV6Eo6SIqUjUy8HctfLyeIfKSlUDhKpJ8VKRzoqBzL1ciJ3vScgHZWDMPztqPl8jtFolBVfSMbjMWq1qky9NIQQJITAdPoDimEYzHWn6PevMBwOi9mZsYHLy8/RJ/KEo25uvsKyLCkWgNFoRI7jAAAMw2CJ/qh6/QCe56HZbKLX6+H4+DUGg0Ha9f4rxuMxbm+/4f7+Hrb9KBKw1HFnmibt7Wl4ePBRq1U3thTuGmEYZoUAABTlV4L5vo9SqYTz8w9RObC2YWwhmKZpcF03NsOQrCSyjldLj20dTybx+0hnuX8TAH4C6vsfOBqSLrQAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-73",
    width: 63,
    height: 27,
    transform: "translate(55.29 27.57)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAAbCAYAAADLYlf/AAAACXBIWXMAAAsSAAALEgHS3X78AAABvklEQVRYR+2Zv2oqQRjFz8xuccNWWwluo9XWFjZuYeMNvomVbyCC+wJi4UuIjyDcRGYRrGxExMJuUVBsxex6UpiYBJK7RUDITH7wFTtzduD7xwwzgiRecRyH+/0eOkESQgjUajVEUQSS4nVOkESlUuFms8F2u8V8Pv/fWj+W0+kE3/ev3ySF7Xkei8UilFIYjUYoFArXyOhEGIaczWY4HA5otVqXwXK5zNVqxU6nQ5LQ3cbjMQFcLAgCPjz8Y9ZPOtl6vWYQBJQA8Pg4/rpeNGS5XAIA5GQyyZDqh5QC5/MZ0rKsLK12SGkhSRJI27aztNohpUSapmY6b1nS5My/lL2JPW985n973kTnf3ve5Mwb2/NxHL+V/d3dnyy9dhhb9sA755MkydJqR5qmkNPpFE9PZjnv+z7y+TxsALi//5ul14YwDOm6LlzXhQDAfr+P3W6Hdrut5eXlexaLBavVKjzPuzgPAMPh8HptrWMQwjBko9FAvV6H4zhQSgmbpBBCsNvtIooi9Ho9HI/Ht5eMG3CLU2YcxyiVSsjlclBKCQCXnufLK4YQgoPBAM1m89MFyK9j8t25W2y5cRx/qOhnMUYr3zSALPsAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-183",
    x: 292.5,
    y: 74.9,
    width: 6.17,
    height: 3.24,
    rx: 0.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-184",
    x: 292.59,
    y: 74.94,
    width: 6.01,
    height: 3.13,
    rx: 0.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-185",
    x: 292.68,
    y: 74.97,
    width: 5.85,
    height: 3.02,
    rx: 0.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 292.78,
    y: 75.01,
    width: 5.68,
    height: 2.91,
    rx: 0.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-187",
    x: 292.87,
    y: 75.04,
    width: 5.52,
    height: 2.8,
    rx: 0.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-188",
    x: 292.96,
    y: 75.08,
    width: 5.35,
    height: 2.69,
    rx: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-189",
    x: 293.05,
    y: 75.11,
    width: 5.19,
    height: 2.58,
    rx: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-190",
    x: 293.14,
    y: 75.15,
    width: 5.02,
    height: 2.47,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-191",
    x: 293.24,
    y: 75.19,
    width: 4.86,
    height: 2.36,
    rx: 0.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-192",
    x: 293.33,
    y: 75.22,
    width: 4.69,
    height: 2.25,
    rx: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-193",
    x: 293.42,
    y: 75.26,
    width: 4.53,
    height: 2.14,
    rx: 0.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-194",
    x: 293.51,
    y: 75.29,
    width: 4.36,
    height: 2.03,
    rx: 0.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-195",
    x: 292.7,
    y: 74.99,
    width: 5.64,
    height: 2.71,
    rx: 0.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-196",
    x: 292.72,
    y: 75,
    width: 5.61,
    height: 2.63,
    rx: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-197",
    x: 292.74,
    y: 75.01,
    width: 5.57,
    height: 2.55,
    rx: 0.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 292.75,
    y: 75.02,
    width: 5.54,
    height: 2.46,
    rx: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-199",
    x: 292.77,
    y: 75.02,
    width: 5.5,
    height: 2.38,
    rx: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 292.79,
    y: 75.03,
    width: 5.47,
    height: 2.3,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-201",
    x: 292.81,
    y: 75.04,
    width: 5.43,
    height: 2.22,
    rx: 0.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-202",
    x: 292.82,
    y: 75.04,
    width: 5.4,
    height: 2.14,
    rx: 0.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-203",
    x: 292.84,
    y: 75.05,
    width: 5.37,
    height: 2.05,
    rx: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-204",
    x: 292.86,
    y: 75.06,
    width: 5.33,
    height: 1.97,
    rx: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-205",
    x: 292.87,
    y: 75.06,
    width: 5.3,
    height: 1.89,
    rx: 0.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-206",
    x: 292.89,
    y: 75.07,
    width: 5.26,
    height: 1.81,
    rx: 0.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-207",
    x: 292.91,
    y: 75.08,
    width: 5.23,
    height: 1.73,
    rx: 0.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-208",
    x: 292.93,
    y: 75.08,
    width: 5.19,
    height: 1.64,
    rx: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-209",
    x: 292.94,
    y: 75.09,
    width: 5.16,
    height: 1.56,
    rx: 0.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-210",
    x: 292.96,
    y: 75.1,
    width: 5.12,
    height: 1.48,
    rx: 0.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-211",
    x: 292.98,
    y: 75.11,
    width: 5.09,
    height: 1.4,
    rx: 0.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-212",
    x: 293,
    y: 75.11,
    width: 5.06,
    height: 1.32,
    rx: 0.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 293.01,
    y: 75.12,
    width: 5.02,
    height: 1.23,
    rx: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-214",
    x: 293.03,
    y: 75.13,
    width: 4.99,
    height: 1.15,
    rx: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-215",
    x: 293.05,
    y: 75.13,
    width: 4.95,
    height: 1.07,
    rx: 0.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-216",
    x: 293.06,
    y: 75.14,
    width: 4.92,
    height: 0.99,
    rx: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-217",
    d: "M293.15,75.46a20.07,20.07,0,0,0,4.75.17c.19-.22.14-.46-.44-.49S293.12,75.13,293.15,75.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "M26.82,18.66a.47.47,0,0,1,.47-.47H248c4.32,0,5,.27,5.46.75l-2.78.85H27.29a.47.47,0,0,1-.47-.47Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-219",
    points: "258.38 20.16 254.55 20.16 288.48 55.01 293.6 55.19 258.38 20.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-132",
    points: "259.32 21.07 257.04 18.79 253.21 18.79 288.48 55.01 289 55.03 255.93 21.19 259.32 21.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-220",
    points: "214.09 114.97 214.09 0.51 214.86 0.57 214.86 114.99 214.09 114.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "213.33 114.99 213.33 0.46 214.09 0.51 214.09 114.97 213.33 114.99"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-222",
    x: 41.53,
    y: 63.6,
    width: 87.17,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-223",
    x: 41.53,
    y: 70.55,
    width: 87.17,
    height: 2.6
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-224",
    points: "128.7 114.69 128.7 0 129.47 0 129.47 114.67 128.7 114.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-225",
    points: "127.93 114.66 127.93 0 128.7 0 128.7 114.69 127.93 114.66"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-226",
    x: -15.26,
    y: 56.82,
    width: 114.4,
    height: 0.77,
    transform: "translate(-15.26 99.14) rotate(-90)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-227",
    points: "40.79 114.02 40.79 0 41.56 0 41.56 114.4 40.79 114.02"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-228",
    x: 42.68,
    y: 67.12,
    width: 86.02,
    height: 2.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-229",
    x: 41.53,
    y: 66.2,
    width: 3.7,
    height: 4.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-230",
    d: "M125.93,66.2h2.77a0,0,0,0,1,0,0v4.35a0,0,0,0,1,0,0h-2.77a.93.93,0,0,1-.93-.93V67.13A.93.93,0,0,1,125.93,66.2Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVan);
export default __webpack_public_path__ + "static/media/van.b742e3e388d3b3735f35ced11bf79a39.svg";
export { ForwardRef as ReactComponent };